// src/pages/AdminPanelTabs.jsx - TÜM TABLAR (ESKİ + YENİ)
import React, { useState, useEffect } from 'react';
import {
  Package, Plus, Search, Edit2, Trash2, TrendingUp, DollarSign,
  RefreshCw, Tag, Percent, Calendar, CheckCircle, XCircle, AlertTriangle,
  Download, Eye, Activity, BarChart3, Users,
  Truck, MessageSquare, Star, Award, Send, Mail,
  Phone, ShoppingCart, Clock, TrendingDown, ShoppingBag,
  Save, X, RotateCcw, AlertCircle, ShieldCheck, ThumbsUp, MoreVertical, Globe,
  Monitor, Link, Target, Archive
} from 'lucide-react';
import { getCategoryInfo } from '../config/categoryConfig';
import {
  getRealtimeVisitors,
  getDailyTrend,
  getHourlyDistribution,
  getDeviceData,
  getBrowserData,
  getVisitorAnalytics,
  getTrafficSources
} from '../services/ga4Service';
import { getAllProducts } from '../services/productService';
import AnalyticsProductCard from '../components/AnalyticsProductCard';
import { shipOrder } from '../services/orderService';
import toast from 'react-hot-toast';

// ==================== DASHBOARD TAB ====================
export function DashboardTab({ stats, products, campaigns, orders = [] }) {
  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">📊 Dashboard</h2>
      </div>

      <div className="stats-grid">
        {[
          {
            icon: Package,
            label: 'Toplam Ürün',
            value: stats.totalProducts,
            color: '#E5332A',
            subtext: `${stats.activeProducts} aktif`
          },
          {
            icon: DollarSign,
            label: 'Toplam Değer',
            value: `${stats.totalRevenue.toLocaleString('tr-TR')}₺`,
            color: '#4CAF50',
            subtext: 'Stok değeri'
          },
          {
            icon: TrendingUp,
            label: 'Toplam Stok',
            value: stats.totalStock,
            color: '#2196F3',
            subtext: 'Adet'
          },
          {
            icon: AlertTriangle,
            label: 'Düşük Stok',
            value: stats.lowStockProducts,
            color: '#FF9800',
            subtext: 'Uyarı seviyesi'
          },
          {
            icon: Percent,
            label: 'İndirimli Ürün',
            value: stats.discountedProducts,
            color: '#9C27B0',
            subtext: `Ort. %${(stats.averageDiscount || 0).toFixed(1)}`
          },
          {
            icon: Tag,
            label: 'Aktif Kampanya',
            value: stats.activeCampaigns,
            color: '#00BCD4',
            subtext: 'Devam ediyor'
          },
          {
            icon: ShoppingCart,
            label: 'Toplam Sipariş',
            value: stats.totalOrders || 0,
            color: '#FF5722',
            subtext: `${stats.pendingOrders || 0} bekliyor`
          },
          {
            icon: Activity,
            label: 'Toplam Satış',
            value: stats.totalSales || 0,
            color: '#795548',
            subtext: 'Adet'
          }
        ].map((stat, i) => (
          <div key={i} className="stat-card" style={{ borderColor: stat.color }}>
            <div className="stat-card-inner">
              <div>
                <p className="stat-label">{stat.label}</p>
                <p className="stat-value">{stat.value}</p>
                {stat.subtext && <p className="stat-subtext">{stat.subtext}</p>}
              </div>
              <div className="stat-icon" style={{ background: `${stat.color}20` }}>
                <stat.icon size={26} color={stat.color} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Hızlı Bilgiler */}
      <div className="quick-info-grid">
        <div className="info-card">
          <h3>🔥 En Çok İndirimli Ürünler</h3>
          <div className="info-list">
            {products
              .filter(p => p.discount > 0)
              .sort((a, b) => b.discount - a.discount)
              .slice(0, 5)
              .map(p => (
                <div key={p.id} className="info-item">
                  <span className="info-name">{p.name}</span>
                  <span className="info-badge discount">-{p.discount}%</span>
                </div>
              ))}
          </div>
        </div>

        <div className="info-card">
          <h3>⚠️ Düşük Stoklu Ürünler</h3>
          <div className="info-list">
            {products
              .filter(p => p.stock < (p.minStock || 5) && p.stock > 0)
              .sort((a, b) => a.stock - b.stock)
              .slice(0, 5)
              .map(p => (
                <div key={p.id} className="info-item">
                  <span className="info-name">{p.name}</span>
                  <span className="info-badge warning">{p.stock} adet</span>
                </div>
              ))}
          </div>
        </div>

        <div className="info-card">
          <h3>🎯 Aktif Kampanyalar</h3>
          <div className="info-list">
            {campaigns
              .filter(c => new Date(c.endDate) > new Date())
              .slice(0, 5)
              .map(c => (
                <div key={c.id} className="info-item">
                  <span className="info-name">{c.title}</span>
                  <span className="info-badge success">%{c.discountPercent}</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ==================== PRODUCTS TAB ====================
function ProductCard({ product, isSelected, onToggleSelect, onEdit, onDelete, onRemoveDiscount }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const hasDiscount = product.discount > 0;
  const isLowStock = product.stock < (product.minStock || 5) && product.stock > 0;
  const isOutOfStock = product.stock === 0;
  const isInactive = product.isActive === false;

  // Fiyat hesaplama
  const originalPrice = product.originalPrice || product.price || 0;
  const currentPrice = product.currentPrice || product.price || 0;
  const displayDiscount = product.discount || 0;

  // YENİ: Kategori bilgilerini al
  const categoryDisplay = getCategoryInfo(product.category);

  return (
    <article className={`product-card ${isInactive ? 'inactive' : ''}`}>
      {/* Checkbox */}
      <input
        type="checkbox"
        className="product-checkbox"
        checked={isSelected}
        onChange={onToggleSelect}
        onClick={(e) => e.stopPropagation()}
      />

      {/* Discount Badge */}
      {hasDiscount && (
        <div className="discount-badge-product">
          %{Math.round(displayDiscount)}
        </div>
      )}

      {/* Inactive Overlay */}
      {isInactive && <div className="inactive-overlay">Pasif</div>}

      {/* Product Image */}
      <div className="product-image">
        {!imageLoaded && <div className="image-skeleton"></div>}
        <img
          src={product.image || 'https://via.placeholder.com/300x300/2B2B2B/FFFFFF?text=Görsel+Yok'}
          alt={product.name}
          onLoad={() => setImageLoaded(true)}
          style={{
            display: imageLoaded ? 'block' : 'none',
            objectFit: 'contain',
            background: '#fff',
            padding: '8px'
          }}
        />
      </div>

      {/* Product Info */}
      <div className="product-info">
        {/* Header: SKU & Brand */}
        <div className="product-header">
          <span className="product-sku">{product.sku || 'SKU yok'}</span>
          {product.brand && <span className="product-brand-tag">{product.brand}</span>}
        </div>

        {/* Product Name */}
        <div className="product-brand">{product.name}</div>

        {/* Category - YENİ: Emoji desteği eklendi */}
        <p className="product-category">
          {categoryDisplay.emoji && (
            <span className="category-emoji">{categoryDisplay.emoji}</span>
          )}
          <span className="category-text">
            {categoryDisplay.subCategory || categoryDisplay.mainCategory || 'Kategori belirtilmemiş'}
          </span>
        </p>

        {/* Description */}
        {product.description && (
          <div className="product-desc">
            {product.description}
          </div>
        )}

        {/* Rating & Sales */}
        <div className="product-rating">
          <Star size={14} fill="#ffc107" stroke="#ffc107" />
          <span>{product.rating || '4.5'}</span>
          <span className="reviews">
            {product.sales > 0 ? `${product.sales} satış` : 'Yeni ürün'}
          </span>
        </div>

        {/* Footer: Price & Stock */}
        <div className="product-footer">
          <div className="product-price">
            {hasDiscount && (
              <span className="old-price">
                {originalPrice.toFixed(2)}₺
              </span>
            )}
            <span className="current-price">
              {currentPrice.toFixed(2)}₺
            </span>
          </div>

          {/* Stock Badge */}
          <span className={`stock-badge ${isOutOfStock ? 'stock-out' : isLowStock ? 'stock-low' : 'stock-ok'}`}>
            {isOutOfStock ? 'Tükendi' : isLowStock ? `⚠️ ${product.stock}` : `✓ ${product.stock}`}
          </span>
        </div>

        {/* Action Buttons */}
        <div className="product-actions">
          <button
            className="edit-btn"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <Edit2 size={16} /> Düzenle
          </button>
          {hasDiscount && (
            <button
              className="remove-discount-btn"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveDiscount();
              }}
              title="İndirimi Kaldır"
            >
              <Percent size={16} />
            </button>
          )}
          <button
            className="delete-btn"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>

      <style jsx>{`
        .product-card {
          position: relative;
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 1px solid #e9ecef;
          cursor: pointer;
        }

        .product-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0,0,0,0.1);
        }

        .product-card.inactive {
          opacity: 0.6;
        }

        .product-checkbox {
          position: absolute;
          top: 12px;
          left: 12px;
          width: 20px;
          height: 20px;
          cursor: pointer;
          z-index: 5;
          accent-color: #E5332A;
        }

        .discount-badge-product {
          position: absolute;
          top: 12px;
          right: 12px;
          background: linear-gradient(135deg, #E5332A, #ff6b6b);
          color: #fff;
          padding: 6px 12px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 14px;
          z-index: 2;
          box-shadow: 0 2px 8px rgba(229, 51, 42, 0.3);
        }

        .inactive-overlay {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: rgba(0,0,0,0.7);
          color: #fff;
          padding: 8px 16px;
          border-radius: 8px;
          font-weight: 600;
          z-index: 3;
        }

        .product-image {
          position: relative;
          width: 100%;
          height: 220px;
          overflow: hidden;
          background: #fff;
        }

        .product-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .image-skeleton {
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
        }

        @keyframes loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        .product-info {
          padding: 16px;
        }

        .product-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .product-sku {
          font-size: 11px;
          color: #868e96;
          font-weight: 500;
        }

        .product-brand-tag {
          background: #f8f9fa;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 10px;
          color: #495057;
          font-weight: 600;
        }

        .product-brand {
          font-size: 15px;
          font-weight: 600;
          color: #2B2B2B;
          margin-bottom: 4px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .product-category {
          font-size: 12px;
          color: #868e96;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .category-emoji {
          font-size: 16px;
          line-height: 1;
        }

        .category-text {
          flex: 1;
        }

        .product-desc {
          font-size: 12px;
          color: #495057;
          margin-bottom: 12px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          line-height: 1.4;
        }

        .product-rating {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-bottom: 12px;
          font-size: 13px;
          color: #495057;
        }

        .reviews {
          color: #868e96;
          font-size: 12px;
        }

        .product-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .product-price {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .old-price {
          font-size: 12px;
          color: #868e96;
          text-decoration: line-through;
        }

        .current-price {
          font-size: 18px;
          font-weight: 700;
          color: #E5332A;
        }

        .campaign-label {
          display: inline-block;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 4px;
          background: rgba(229, 51, 42, 0.1);
          color: #E5332A;
          font-weight: 600;
        }

        .stock-badge {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 600;
        }

        .stock-ok {
          background: rgba(6, 214, 160, 0.1);
          color: #06d6a0;
        }

        .stock-low {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
        }

        .stock-out {
          background: rgba(229, 51, 42, 0.1);
          color: #E5332A;
        }

        .tag {
          font-size: 10px;
          padding: 3px 8px;
          background: #f8f9fa;
          color: #495057;
          border-radius: 4px;
        }

        .product-actions {
          display: flex;
          gap: 8px;
        }

        .edit-btn, .remove-discount-btn, .delete-btn {
          flex: 1;
          padding: 8px;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.2s;
        }

        .edit-btn {
          background: #f8f9fa;
          color: #495057;
        }

        .edit-btn:hover {
          background: #e9ecef;
        }

        .remove-discount-btn {
          background: rgba(245, 158, 11, 0.1);
          color: #f59e0b;
          flex: 0 0 auto;
          padding: 8px 12px;
        }

        .remove-discount-btn:hover {
          background: rgba(245, 158, 11, 0.2);
        }

        .delete-btn {
          background: rgba(229, 51, 42, 0.1);
          color: #E5332A;
          flex: 0 0 auto;
          padding: 8px 12px;
        }

        .delete-btn:hover {
          background: rgba(229, 51, 42, 0.2);
        }
      `}</style>
    </article>
  );
}

export function ProductsTab({
  filteredProducts, searchTerm, setSearchTerm, filterCategory, setFilterCategory,
  filterStatus, setFilterStatus, filterStock, setFilterStock, sortBy, setSortBy,
  categoryConfig, setShowAddProduct, setEditingProduct, handleDeleteProduct,
  exportProducts, refreshing, fetchAllData, loading
  // ❌ KALDIRILDI: selectedProducts, toggleProductSelection, selectAll, deselectAll
  // ❌ KALDIRILDI: handleRemoveDiscount, setDiscountTargetProducts, setShowDiscountModal
}) {

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">📦 Ürün Yönetimi</h2>
        <button className="btn btn-primary" onClick={() => setShowAddProduct(true)}>
          <Plus size={18} /> Yeni Ürün
        </button>
      </div>

      {/* Toolbar */}
      <div className="toolbar">
        <div className="search-bar">
          <Search size={18} />
          <input
            type="text"
            placeholder="Ürün, kategori veya SKU ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="toolbar-divider"></div>

        <div className="toolbar-section">
          <div className="select-wrapper">
            <select className="select" value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
              <option value="all">🏷️ Tüm Kategoriler</option>
              <optgroup label="─────────────"></optgroup>
              {Object.entries(categoryConfig).map(([mainCat, data]) => (
                <React.Fragment key={mainCat}>
                  <option value={mainCat} style={{ fontWeight: 'bold' }}>
                    {data.emoji} {mainCat}
                  </option>
                  {data.subcategories && Object.entries(data.subcategories).map(([subCat, subData]) => (
                    <option key={`${mainCat}>${subCat}`} value={`${mainCat} > ${subCat}`} style={{ paddingLeft: '20px' }}>
                      &nbsp;&nbsp;&nbsp;{subData.emoji} {subCat}
                    </option>
                  ))}
                </React.Fragment>
              ))}
            </select>
          </div>

          <div className="select-wrapper">
            <select className="select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
              <option value="all">Tüm Durumlar</option>
              <option value="active">✅ Aktif</option>
              <option value="inactive">❌ Pasif</option>
            </select>
          </div>

          <div className="select-wrapper">
            <select className="select" value={filterStock} onChange={(e) => setFilterStock(e.target.value)}>
              <option value="all">Tüm Stoklar</option>
              <option value="instock">📦 Stokta</option>
              <option value="lowstock">⚠️ Düşük Stok</option>
              <option value="outofstock">❌ Tükendi</option>
            </select>
          </div>

          <div className="select-wrapper">
            <select className="select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="newest">🆕 En Yeni</option>
              <option value="name">🔤 İsme Göre</option>
              <option value="price-asc">💰 Fiyat (↑)</option>
              <option value="price-desc">💰 Fiyat (↓)</option>
              <option value="stock-asc">📦 Stok (↑)</option>
              <option value="stock-desc">📦 Stok (↓)</option>
              <option value="discount">🏷️ İndirim</option>
              <option value="sales">📈 Satış</option>
            </select>
          </div>
        </div>

        <div className="toolbar-divider"></div>

        <div className="toolbar-section">
          <button className="btn btn-icon" onClick={exportProducts} title="Dışa Aktar">
            <Download size={18} />
          </button>

          <button className="btn btn-outline" onClick={fetchAllData} disabled={refreshing}>
            <RefreshCw size={18} className={refreshing ? 'spin' : ''} />
            Yenile
          </button>
        </div>
      </div>

      {/* Products Grid */}
      {loading ? (
        <div className="loading-grid">
          {[...Array(6)].map((_, i) => <div key={i} className="skeleton-card"></div>)}
        </div>
      ) : filteredProducts.length === 0 ? (
        <div className="empty-state">
          <Package size={64} color="#E5332A" />
          <p>{searchTerm ? 'Arama kriterlerinize uygun ürün bulunamadı.' : 'Henüz ürün bulunmuyor.'}</p>
          <button className="btn btn-primary" onClick={() => setShowAddProduct(true)} style={{ marginTop: '1rem' }}>
            <Plus size={18} /> İlk Ürünü Ekle
          </button>
        </div>
      ) : (
        <div className="products-grid">
          {filteredProducts.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onEdit={() => setEditingProduct(product)}
              onDelete={() => handleDeleteProduct(product)}
            />
          ))}
        </div>
      )}

      {/* Results Info */}
      {!loading && filteredProducts.length > 0 && (
        <div className="results-info">
          <p>
            Toplam <strong>{filteredProducts.length}</strong> ürün gösteriliyor
          </p>
        </div>
      )}

      <style jsx>{`
        .loading-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .skeleton-card {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 12px;
          height: 450px;
        }

        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }

        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          text-align: center;
          color: #868e96;
        }

        .empty-state svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-state p {
          margin: 0 0 1rem;
          font-size: 16px;
        }

        .results-info {
          padding: 1.5rem;
          text-align: center;
          color: #495057;
          font-size: 14px;
          border-top: 2px solid #e9ecef;
          margin-top: 2rem;
        }

        .results-info strong {
          color: #E5332A;
          font-weight: 700;
        }

        @media (max-width: 768px) {
          .products-grid {
            grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
            gap: 1rem;
          }
        }
      `}</style>
    </div>
  );
}

// ==================== DISCOUNTS TAB ====================
// ==================== DISCOUNTS TAB - SADECE İZLEME ====================
export function DiscountsTab({ products }) {
  const discountedProducts = products.filter(p => p.discount > 0 && p.campaignId);

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">💰 İndirimli Ürünler</h2>
        <p className="page-subtitle">Kampanyalar tarafından indirim uygulanmış ürünler</p>
      </div>

      {discountedProducts.length === 0 ? (
        <div className="empty-state">
          <Percent size={64} color="#E5332A" />
          <p>Henüz kampanyalı ürün bulunmuyor</p>
          <small style={{ color: '#868e96', marginTop: '8px' }}>
            Kampanyalar sekmesinden yeni kampanya oluşturabilirsiniz
          </small>
        </div>
      ) : (
        <>
          <div className="discount-summary">
            <div className="summary-card">
              <div className="summary-icon">
                <Percent size={32} />
              </div>
              <div className="summary-content">
                <h3>{discountedProducts.length}</h3>
                <p>Kampanyalı Ürün</p>
              </div>
            </div>

            <div className="summary-card">
              <div className="summary-icon">
                <TrendingUp size={32} />
              </div>
              <div className="summary-content">
                <h3>%{(discountedProducts.reduce((sum, p) => sum + p.discount, 0) / discountedProducts.length).toFixed(1)}</h3>
                <p>Ortalama İndirim</p>
              </div>
            </div>

            <div className="summary-card">
              <div className="summary-icon">
                <DollarSign size={32} />
              </div>
              <div className="summary-content">
                <h3>{discountedProducts.reduce((sum, p) => sum + ((p.originalPrice || p.price) - (p.currentPrice || p.price)) * p.stock, 0).toFixed(0)}₺</h3>
                <p>Toplam İndirim Değeri</p>
              </div>
            </div>
          </div>

          <div className="discount-list">
            {discountedProducts.map(product => (
              <div key={product.id} className="discount-item">
                <img src={product.image} alt={product.name} className="discount-item-image" />
                <div className="discount-item-content">
                  <h4>{product.name}</h4>
                  <p className="discount-item-category">{product.category}</p>
                  
                  {/* Kampanya Bilgisi */}
                  <div className="campaign-info-badge">
                    <Tag size={12} />
                    <span>{product.campaignTitle}</span>
                  </div>

                  <div className="discount-item-prices">
                    <span className="old-price">{(product.originalPrice || product.price).toFixed(2)}₺</span>
                    <span className="new-price">{(product.currentPrice || product.price).toFixed(2)}₺</span>
                    <span className="discounts-tab-badge">-%{product.discount}</span>
                  </div>
                  
                  {product.discountEndDate && (
                    <p className="discount-date">
                      <Calendar size={14} /> 
                      {product.discountEndDate === null || product.discountEndDate === 'null'
                        ? 'Süresiz'
                        : `Bitiş: ${new Date(product.discountEndDate).toLocaleDateString('tr-TR')}`
                      }
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <style jsx>{`
        .page-subtitle {
          font-size: 14px;
          color: #868e96;
          margin-top: 8px;
        }

        .discount-summary {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .summary-card {
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .summary-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #E5332A 0%, #c72a22 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .summary-content h3 {
          font-size: 28px;
          font-weight: 700;
          color: #2B2B2B;
          margin-bottom: 4px;
        }

        .summary-content p {
          font-size: 14px;
          color: #868e96;
          margin: 0;
        }

        .discount-list {
          display: grid;
          gap: 1rem;
        }

        .discount-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px;
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          transition: all 0.2s;
        }

        .discount-item:hover {
          border-color: #E5332A;
          box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
        }

        .discount-item-image {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 8px;
          background: #f8f9fa;
        }

        .discount-item-content {
          flex: 1;
        }

        .discount-item-content h4 {
          font-size: 16px;
          font-weight: 600;
          color: #2B2B2B;
          margin-bottom: 4px;
        }

        .discount-item-category {
          font-size: 13px;
          color: #868e96;
          margin-bottom: 8px;
        }

        .campaign-info-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          background: #fff5f5;
          color: #E5332A;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 600;
          margin-bottom: 8px;
        }

        .discount-item-prices {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 8px;
        }

        .old-price {
          font-size: 14px;
          color: #868e96;
          text-decoration: line-through;
        }

        .new-price {
          font-size: 18px;
          font-weight: 700;
          color: #E5332A;
        }

        .discounts-tab-badge {
          background: #E5332A;
          color: #fff;
          font-size: 12px;
          font-weight: 700;
          padding: 4px 8px;
          border-radius: 6px;
          white-space: nowrap;
        }

        .discount-date {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #495057;
          margin: 0;
        }
      `}</style>
    </div>
  );
}

// ==================== CAMPAIGNS TAB - DÜZELTILMIŞ VERSİYON ====================
export function CampaignsTab({ campaigns, setShowAddCampaign, setEditingCampaign, handleDeleteCampaign }) {
  
  // Aktif/Pasif kampanyaları ayır
  const activeCampaigns = campaigns.filter(c => {
    const now = new Date();
    const endDate = c.endDate ? new Date(c.endDate) : null;
    return c.isActive && (!endDate || endDate > now);
  });

  const expiredCampaigns = campaigns.filter(c => {
    const now = new Date();
    const endDate = c.endDate ? new Date(c.endDate) : null;
    return !c.isActive || (endDate && endDate <= now);
  });

  // Kampanya tipi badge
  const getCampaignTypeBadge = (campaign) => {
    const types = {
      general: { label: 'Genel', color: '#6366f1', emoji: '🌐' },
      category: { label: 'Kategori', color: '#8b5cf6', emoji: '📂' },
      subcategory: { label: 'Alt Kategori', color: '#a855f7', emoji: '📁' },
      product: { label: 'Tek Ürün', color: '#ec4899', emoji: '📦' }
    };
    return types[campaign.campaignType] || types.general;
  };

  // İndirim tipi badge
  const getDiscountTypeBadge = (campaign) => {
    if (campaign.discountType === 'discount') {
      return { label: `%${campaign.discountPercent} İndirim`, color: '#E5332A', emoji: '💰' };
    } else if (campaign.discountType === 'free_shipping') {
      return { label: `${campaign.freeShippingThreshold}₺+ Ücretsiz Kargo`, color: '#10b981', emoji: '🚚' };
    }
    // ESKİ SİSTEM UYUMLULUĞU
    if (campaign.campaignType === 'free_shipping') {
      return { label: `${campaign.freeShippingThreshold}₺+ Ücretsiz Kargo`, color: '#10b981', emoji: '🚚' };
    }
    return { label: `%${campaign.discountPercent || 0} İndirim`, color: '#E5332A', emoji: '💰' };
  };

  // Tarih formatı
  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === 'null' || dateStr === null) return 'Süresiz';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch {
      return 'Süresiz';
    }
  };

  // Kalan gün sayısı
  const getRemainingDays = (endDate) => {
    if (!endDate || endDate === 'null' || endDate === null) return { text: 'Süresiz', isExpired: false };
    try {
      const now = new Date();
      const end = new Date(endDate);
      const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      
      if (diff < 0) return { text: 'Sona erdi', isExpired: true };
      if (diff === 0) return { text: 'Bugün bitiyor', isExpired: false };
      if (diff === 1) return { text: '1 gün kaldı', isExpired: false };
      return { text: `${diff} gün kaldı`, isExpired: false };
    } catch {
      return { text: 'Süresiz', isExpired: false };
    }
  };

  return (
    <div className="campaigns-tab-container">
      {/* Header */}
      <div className="campaigns-header">
        <div className="campaigns-header-text">
          <h2 className="campaigns-title">🎯 Kampanya Yönetimi</h2>
          <p className="campaigns-subtitle">
            {activeCampaigns.length} aktif kampanya • {expiredCampaigns.length} sona ermiş
          </p>
        </div>
        <button className="btn btn-primary" onClick={() => setShowAddCampaign(true)}>
          <Plus size={18} /> Yeni Kampanya
        </button>
      </div>

      {/* AKTİF KAMPANYALAR */}
      {activeCampaigns.length > 0 && (
        <div className="campaigns-section">
          <h3 className="campaigns-section-title">
            <Activity size={20} /> Aktif Kampanyalar
          </h3>
          <div className="campaigns-grid">
            {activeCampaigns.map(campaign => {
              const typeBadge = getCampaignTypeBadge(campaign);
              const discountBadge = getDiscountTypeBadge(campaign);
              const remaining = getRemainingDays(campaign.endDate);

              return (
                <div key={campaign.id} className="campaign-card active-campaign">
                  {/* Header */}
                  <div className="campaign-card-header">
                    <div className="campaign-card-badges">
                      <span className="campaign-badge" style={{ backgroundColor: typeBadge.color }}>
                        {typeBadge.emoji} {typeBadge.label}
                      </span>
                      <span className="campaign-badge" style={{ backgroundColor: discountBadge.color }}>
                        {discountBadge.emoji} {discountBadge.label}
                      </span>
                    </div>
                    <div className="campaign-card-actions">
                      <button
                        className="campaign-icon-btn"
                        onClick={() => setEditingCampaign(campaign)}
                        title="Düzenle"
                      >
                        <Edit2 size={16} />
                      </button>
                      <button
                        className="campaign-icon-btn danger-btn"
                        onClick={() => handleDeleteCampaign(campaign)}
                        title="Sil"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="campaign-card-body">
                    <h4 className="campaign-card-title">{campaign.title}</h4>

                    {campaign.description && (
                      <p className="campaign-card-description">{campaign.description}</p>
                    )}

                    {/* Target */}
                    {campaign.targetName && (
                      <div className="campaign-info-row">
                        <Target size={14} />
                        <span>{campaign.targetName}</span>
                      </div>
                    )}

                    {/* Min Purchase */}
                    {campaign.minPurchase > 0 && (
                      <div className="campaign-info-row">
                        <DollarSign size={14} />
                        <span>Min. {campaign.minPurchase}₺</span>
                      </div>
                    )}

                    {/* Date Range */}
                    <div className="campaign-dates-row">
                      <div className="campaign-date-item">
                        <Calendar size={14} />
                        <span>{formatDate(campaign.startDate)}</span>
                      </div>
                      {campaign.endDate && campaign.endDate !== 'null' && (
                        <>
                          <span className="campaign-date-separator">→</span>
                          <div className="campaign-date-item">
                            <Calendar size={14} />
                            <span>{formatDate(campaign.endDate)}</span>
                          </div>
                        </>
                      )}
                    </div>

                    {/* Remaining Days */}
                    {campaign.endDate && campaign.endDate !== 'null' && (
                      <div className={`campaign-remaining-badge ${remaining.isExpired ? 'expired-badge' : 'active-badge'}`}>
                        <Clock size={14} />
                        <span>{remaining.text}</span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* SONA ERMİŞ KAMPANYALAR */}
      {expiredCampaigns.length > 0 && (
        <div className="campaigns-section">
          <h3 className="campaigns-section-title">
            <Archive size={20} /> Sona Ermiş Kampanyalar
          </h3>
          <div className="campaigns-grid">
            {expiredCampaigns.map(campaign => {
              const typeBadge = getCampaignTypeBadge(campaign);

              return (
                <div key={campaign.id} className="campaign-card expired-campaign">
                  <div className="campaign-card-header">
                    <div className="campaign-card-badges">
                      <span className="campaign-badge badge-gray">
                        {typeBadge.emoji} {typeBadge.label}
                      </span>
                      <span className="campaign-badge badge-expired">Sona Erdi</span>
                    </div>
                    <button
                      className="campaign-icon-btn danger-btn"
                      onClick={() => handleDeleteCampaign(campaign)}
                      title="Sil"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>

                  <div className="campaign-card-body">
                    <h4 className="campaign-card-title">{campaign.title}</h4>

                    {campaign.description && (
                      <p className="campaign-card-description">{campaign.description}</p>
                    )}

                    <div className="campaign-dates-row">
                      <div className="campaign-date-item">
                        <Calendar size={14} />
                        <span>{formatDate(campaign.startDate)}</span>
                      </div>
                      <span className="campaign-date-separator">→</span>
                      <div className="campaign-date-item">
                        <Calendar size={14} />
                        <span>{formatDate(campaign.endDate)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* EMPTY STATE */}
      {campaigns.length === 0 && (
        <div className="campaigns-empty-state">
          <Tag size={64} />
          <h3>Henüz kampanya oluşturulmamış</h3>
          <p>İlk kampanyanızı oluşturmak için yukarıdaki butona tıklayın</p>
          <button className="btn btn-primary" onClick={() => setShowAddCampaign(true)}>
            <Plus size={18} /> İlk Kampanyayı Oluştur
          </button>
        </div>
      )}

      <style jsx>{`
        /* Container */
        .campaigns-tab-container {
          padding: 0;
          width: 100%;
        }

        /* Header */
        .campaigns-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 32px;
          flex-wrap: wrap;
          gap: 16px;
        }

        .campaigns-header-text {
          flex: 1;
          min-width: 200px;
        }

        .campaigns-title {
          font-size: 28px;
          font-weight: 700;
          color: #2B2B2B;
          margin: 0 0 8px 0;
        }

        .campaigns-subtitle {
          font-size: 14px;
          color: #868e96;
          margin: 0;
        }

        /* Section */
        .campaigns-section {
          margin-bottom: 40px;
        }

        .campaigns-section-title {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 20px;
          font-weight: 600;
          color: #2B2B2B;
          margin: 0 0 20px 0;
          padding-bottom: 12px;
          border-bottom: 2px solid #e9ecef;
        }

        /* Grid */
        .campaigns-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 20px;
        }

        @media (max-width: 768px) {
          .campaigns-grid {
            grid-template-columns: 1fr;
          }
        }

        /* Campaign Card */
        .campaign-card {
          background: white;
          border: 2px solid #e9ecef;
          border-radius: 12px;
          padding: 20px;
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .campaign-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }

        .campaign-card.active-campaign {
          border-color: #E5332A;
          background: linear-gradient(to bottom, #fff5f5 0%, white 100%);
        }

        .campaign-card.expired-campaign {
          opacity: 0.7;
          background: #f8f9fa;
        }

        /* Card Header */
        .campaign-card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
        }

        .campaign-card-badges {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          flex: 1;
        }

        .campaign-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          color: white;
          white-space: nowrap;
        }

        .badge-gray {
          background-color: #6c757d !important;
        }

        .badge-expired {
          background-color: #dc3545 !important;
        }

        .campaign-card-actions {
          display: flex;
          gap: 6px;
          flex-shrink: 0;
        }

        .campaign-icon-btn {
          width: 32px;
          height: 32px;
          padding: 0;
          border: none;
          background: #f8f9fa;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #495057;
        }

        .campaign-icon-btn:hover {
          background: #e9ecef;
          transform: scale(1.1);
        }

        .campaign-icon-btn.danger-btn:hover {
          background: #fee;
          color: #dc3545;
        }

        /* Card Body */
        .campaign-card-body {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .campaign-card-title {
          font-size: 18px;
          font-weight: 700;
          color: #2B2B2B;
          margin: 0;
          line-height: 1.4;
        }

        .campaign-card-description {
          font-size: 14px;
          color: #868e96;
          margin: 0;
          line-height: 1.6;
        }

        .campaign-info-row {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #495057;
        }

        .campaign-info-row svg {
          color: #868e96;
          flex-shrink: 0;
        }

        .campaign-dates-row {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .campaign-date-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #495057;
        }

        .campaign-date-item svg {
          color: #868e96;
          flex-shrink: 0;
        }

        .campaign-date-separator {
          color: #E5332A;
          font-weight: 700;
          font-size: 16px;
        }

        .campaign-remaining-badge {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
        }

        .campaign-remaining-badge svg {
          flex-shrink: 0;
        }

        .campaign-remaining-badge.active-badge {
          background: #d4edda;
          color: #155724;
        }

        .campaign-remaining-badge.expired-badge {
          background: #f8d7da;
          color: #721c24;
        }

        /* Empty State */
        .campaigns-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 80px 20px;
          text-align: center;
          color: #868e96;
        }

        .campaigns-empty-state svg {
          margin-bottom: 24px;
          opacity: 0.3;
          color: #E5332A;
        }

        .campaigns-empty-state h3 {
          font-size: 20px;
          font-weight: 600;
          margin: 0 0 12px 0;
          color: #2B2B2B;
        }

        .campaigns-empty-state p {
          font-size: 14px;
          margin: 0 0 24px 0;
          max-width: 400px;
        }
      `}</style>
    </div>
  );
}

// ORDERS TAB
export function OrdersTab({ orders = [], onOrderClick, onStatusUpdate, refreshing, fetchAllData }) {
  const [loadingShipment, setLoadingShipment] = useState(null);

  useEffect(() => {
    console.log('🔍 OrdersTab - orders prop:', {
      length: orders?.length || 0,
      isArray: Array.isArray(orders),
      firstOrder: orders?.[0] || null,
      orders: orders
    });
  }, [orders]);

  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('newest');

  const getStatusColor = (status) => {
    const colors = {
      pending: '#FF9800',
      processing: '#2196F3',
      shipped: '#9C27B0',
      delivered: '#4CAF50',
      cancelled: '#E5332A',
      returned: '#FF9800' // ← EKLE
    };
    return colors[status] || '#868e96';
  };

  const getStatusText = (status) => {
    const texts = {
      pending: 'Beklemede',
      processing: 'Hazırlanıyor',
      shipped: 'Kargoda',
      delivered: 'Teslim Edildi',
      cancelled: 'İptal Edildi',
      returned: 'İade Edildi' // ← EKLE
    };
    return texts[status] || status;
  };

  // ✅ İADE DURUMU BADGE FUNKSİYONU
  const getReturnStatusBadge = (returnStatus) => {
    if (!returnStatus) return null;

    const statusConfig = {
      pending: { label: 'İade Bekliyor', color: '#FF9800', bg: '#FFF3E0' },
      approved: { label: 'İade Onaylandı', color: '#2196F3', bg: '#E3F2FD' },
      received: { label: 'İade Alındı', color: '#9C27B0', bg: '#F3E5F5' },
      completed: { label: 'İade Tamamlandı', color: '#4CAF50', bg: '#E8F5E9' },
      rejected: { label: 'İade Reddedildi', color: '#E5332A', bg: '#FFEBEE' }
    };

    const config = statusConfig[returnStatus];
    if (!config) return null;

    return (
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.4rem 1rem',
        background: config.bg,
        color: config.color,
        borderRadius: '8px',
        fontSize: '12px',
        fontWeight: '600',
        marginLeft: '0.5rem'
      }}>
        <RotateCcw size={14} />
        {config.label}
      </div>
    );
  };

  const filteredOrders = orders
    .filter(order => {
      const matchesStatus = filterStatus === 'all' || order.status === filterStatus;
      const matchesSearch =
        order.orderNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.customerEmail?.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesStatus && matchesSearch;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.createdAt) - new Date(a.createdAt);
        case 'oldest':
          return new Date(a.createdAt) - new Date(b.createdAt);
        case 'price-desc':
          return b.total - a.total;
        case 'price-asc':
          return a.total - b.total;
        default:
          return 0;
      }
    });

  const orderStats = {
    total: orders.length,
    pending: orders.filter(o => o.status === 'pending').length,
    processing: orders.filter(o => o.status === 'processing').length,
    shipped: orders.filter(o => o.status === 'shipped').length,
    delivered: orders.filter(o => o.status === 'delivered').length,
    cancelled: orders.filter(o => o.status === 'cancelled').length,
    returned: orders.filter(o => o.status === 'returned').length, // ← EKLE
    pendingReturns: orders.filter(o => o.returnStatus === 'pending').length, // ← EKLE
    totalRevenue: orders
      .filter(o => o.status !== 'cancelled' && o.status !== 'returned')
      .reduce((sum, o) => sum + (o.total || 0), 0),
    todayOrders: orders.filter(o =>
      new Date(o.createdAt).toDateString() === new Date().toDateString()
    ).length
  };

  const handleShipOrder = async (orderId) => {
    console.log('🚀 handleShipOrder ÇAĞRILDI:', orderId);
    if (!window.confirm('Bu siparişi Sürat Kargo ile kargoya vermek istediğinize emin misiniz?')) {
      return;
    }

    setLoadingShipment(orderId);

    try {
      console.log('📦 shipOrder fonksiyonu çağrılıyor...');
      const result = await shipOrder(orderId);
      console.log('✅ shipOrder sonucu:', result);

      if (result.success) {
        toast.success(`✅ Kargoya verildi!\nTakip No: ${result.trackingNumber}`, {
          duration: 5000
        });

        // Mock uyarısı
        if (result.message?.includes('TEST MODE')) {
          toast('⚠️ ' + result.message, {
            icon: '🧪',
            duration: 4000
          });
        }

        await fetchAllData(); // Listeyi yenile
      } else {
        // Hata durumu
        toast.error(`❌ ${result.error}`, {
          duration: 6000
        });

        // Manuel işlem gerekiyorsa uyar
        if (result.requiresManualAction) {
          toast('⚠️ Sipariş "Hazırlanıyor" durumunda kaldı. Manuel olarak kargoya verin.', {
            icon: '👨‍💼',
            duration: 5000
          });
        }
      }
    } catch (error) {
      console.error('❌ Kargoya verme hatası:', error);
      toast.error('Bir hata oluştu: ' + error.message);
    } finally {
      setLoadingShipment(null);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">📦 Sipariş Yönetimi</h2>
        <button className="btn btn-outline" onClick={fetchAllData} disabled={refreshing}>
          <RefreshCw size={18} className={refreshing ? 'spin' : ''} />
          Yenile
        </button>
      </div>

      {/* Order Stats */}
      <div className="stats-grid">
        <div className="stat-card" style={{ borderColor: '#2196F3' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Sipariş</p>
              <p className="stat-value">{orderStats.total}</p>
              <p className="stat-subtext">{orderStats.todayOrders} bugün</p>
            </div>
            <div className="stat-icon" style={{ background: '#2196F320' }}>
              <ShoppingCart size={26} color="#2196F3" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#FF9800' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Bekleyen</p>
              <p className="stat-value">{orderStats.pending}</p>
              <p className="stat-subtext">İşlem gerekli</p>
            </div>
            <div className="stat-icon" style={{ background: '#FF980020' }}>
              <Clock size={26} color="#FF9800" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#9C27B0' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Kargoda</p>
              <p className="stat-value">{orderStats.shipped}</p>
              <p className="stat-subtext">Yolda</p>
            </div>
            <div className="stat-icon" style={{ background: '#9C27B020' }}>
              <Truck size={26} color="#9C27B0" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#4CAF50' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Teslim Edildi</p>
              <p className="stat-value">{orderStats.delivered}</p>
              <p className="stat-subtext">Başarılı</p>
            </div>
            <div className="stat-icon" style={{ background: '#4CAF5020' }}>
              <CheckCircle size={26} color="#4CAF50" />
            </div>
          </div>
        </div>

        {/* ✅ YENİ STAT: İADE TALEPLERİ */}
        <div className="stat-card" style={{ borderColor: '#FF9800' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">İade Talepleri</p>
              <p className="stat-value">{orderStats.pendingReturns}</p>
              <p className="stat-subtext">İncelenmeli</p>
            </div>
            <div className="stat-icon" style={{ background: '#FF980020' }}>
              <RotateCcw size={26} color="#FF9800" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#4CAF50' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Gelir</p>
              <p className="stat-value">{orderStats.totalRevenue.toFixed(0)}₺</p>
              <p className="stat-subtext">Tamamlanan siparişler</p>
            </div>
            <div className="stat-icon" style={{ background: '#4CAF5020' }}>
              <DollarSign size={26} color="#4CAF50" />
            </div>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="toolbar">
        <div className="search-bar">
          <Search size={18} />
          <input
            type="text"
            placeholder="Sipariş no, müşteri adı veya email ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="toolbar-divider"></div>

        <div className="toolbar-section">
          <select className="select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="all">Tüm Siparişler</option>
            <option value="pending">Beklemede</option>
            <option value="processing">Hazırlanıyor</option>
            <option value="shipped">Kargoda</option>
            <option value="delivered">Teslim Edildi</option>
            <option value="cancelled">İptal Edildi</option>
            <option value="returned">İade Edildi</option>
          </select>

          <select className="select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="newest">En Yeni</option>
            <option value="oldest">En Eski</option>
            <option value="price-desc">Tutar (Yüksek)</option>
            <option value="price-asc">Tutar (Düşük)</option>
          </select>
        </div>
      </div>

      {/* Orders List */}
      <div className="orders-list" style={{
        display: 'grid',
        gap: '1rem'
      }}>
        {filteredOrders.length === 0 ? (
          <div className="empty-state">
            <ShoppingCart size={64} color="#E5332A" />
            <p>Sipariş bulunamadı</p>
          </div>
        ) : (
          filteredOrders.map(order => (
            <div key={order.id} className="order-card" onClick={() => onOrderClick(order)} style={{
              background: 'white',
              padding: '1.5rem',
              borderRadius: '12px',
              border: '2px solid #e9ecef',
              cursor: 'pointer',
              transition: 'all 0.3s'
            }}>
              <div className="order-header" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #f0f0f0'
              }}>
                <div className="order-number" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '16px',
                  color: '#2B2B2B'
                }}>
                  <ShoppingCart size={16} />
                  <strong>#{order.orderNumber}</strong>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <div className="order-status" style={{
                    background: `${getStatusColor(order.status)}20`,
                    color: getStatusColor(order.status),
                    padding: '0.4rem 1rem',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '600'
                  }}>
                    {getStatusText(order.status)}
                  </div>
                  {/* ✅ İADE DURUMU BADGE */}
                  {getReturnStatusBadge(order.returnStatus)}
                </div>
              </div>

              <div className="order-customer" style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1.5rem',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #f0f0f0'
              }}>
                <div className="customer-info" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  <Users size={16} />
                  <span>{order.customerName}</span>
                </div>
                <div className="customer-info" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  <Mail size={16} />
                  <span>{order.customerEmail}</span>
                </div>
                {order.customerPhone && (
                  <div className="customer-info" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: '#666',
                    fontSize: '14px'
                  }}>
                    <Phone size={16} />
                    <span>{order.customerPhone}</span>
                  </div>
                )}
              </div>

              <div className="order-items" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}>
                <div className="items-summary" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#666',
                  fontSize: '14px'
                }}>
                  <Package size={16} />
                  <span>{order.items?.length || 0} ürün</span>
                </div>
                <div className="order-total" style={{
                  fontSize: '20px',
                  color: '#E5332A'
                }}>
                  <strong>{order.total?.toFixed(2)}₺</strong>
                </div>
              </div>

              <div className="order-footer" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div className="order-date" style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#868e96',
                  fontSize: '13px'
                }}>
                  <Clock size={14} />
                  <span>{new Date(order.createdAt).toLocaleString('tr-TR')}</span>
                </div>
                <button
                  className="btn btn-sm btn-outline"
                  onClick={(e) => {
                    e.stopPropagation();
                    onOrderClick(order);
                  }}
                >
                  <Eye size={14} /> Detay
                </button>
              </div>

              {order.status === 'pending' && (
                <div className="quick-actions" style={{
                  display: 'flex',
                  gap: '0.75rem',
                  marginTop: '1rem',
                  paddingTop: '1rem',
                  borderTop: '1px solid #f0f0f0'
                }}>
                  <button
                    className="btn btn-sm"
                    style={{ background: '#2196F3', color: 'white', flex: 1 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onStatusUpdate(order.id, 'processing');
                    }}
                  >
                    Hazırlamaya Başla
                  </button>
                </div>
              )}

              {/* ✅ PROCESSING DURUMUNDAKİ SİPARİŞLER İÇİN */}
              {order.status === 'processing' && (
                <div className="quick-actions" style={{
                  display: 'flex',
                  gap: '0.75rem',
                  marginTop: '1rem',
                  paddingTop: '1rem',
                  borderTop: '1px solid #f0f0f0'
                }}>
                  <button
                    className="btn btn-sm"
                    style={{
                      background: '#9C27B0',
                      color: 'white',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShipOrder(order.id);
                    }}
                    disabled={loadingShipment === order.id}
                  >
                    {loadingShipment === order.id ? (
                      <>
                        <div className="spinner-small"></div>
                        Kargoya Veriliyor...
                      </>
                    ) : (
                      <>
                        <Truck size={16} />
                        📦 Kargoya Ver
                      </>
                    )}
                  </button>
                </div>
              )}

              {/* ✅ KARGO HATASI UYARISI */}
              {order.cargoError && (
                <div style={{
                  marginTop: '1rem',
                  padding: '1rem',
                  background: '#FFEBEE',
                  borderLeft: '4px solid #E5332A',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#C62828'
                }}>
                  <strong>⚠️ Kargo Hatası!</strong>
                  <p style={{ margin: '0.5rem 0 0 0' }}>{order.cargoError.message}</p>
                  <button
                    className="btn btn-sm"
                    style={{
                      background: '#9C27B0',
                      color: 'white',
                      marginTop: '0.5rem'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShipOrder(order.id);
                    }}
                  >
                    🔄 Tekrar Dene
                  </button>
                </div>
              )}

              {/* ✅ İADE TALEBİ UYARISI */}
              {order.returnStatus === 'pending' && (
                <div style={{
                  marginTop: '1rem',
                  padding: '1rem',
                  background: '#FFF3E0',
                  borderLeft: '4px solid #FF9800',
                  borderRadius: '8px',
                  fontSize: '14px',
                  color: '#E65100'
                }}>
                  <strong>⚠️ İade talebi var!</strong> Müşteri iade talebi oluşturdu. Detaylara bakın.
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function getPageName(url) {
  // URL temizleme
  const path = url.split('?')[0]; // Query parametrelerini kaldır

  // Sayfa isimlendirme haritası
  const pageNames = {
    '/': 'Anasayfa',
    '/cart': 'Sepet',
    '/wishlist': 'Favoriler',
    '/checkout': 'Ödeme',
    '/campaigns': 'Kampanyalar',
    '/search': 'Arama',
    '/orders': 'Siparişlerim',
    '/contact': 'İletişim',
    '/faq': 'Sıkça Sorulan Sorular',
    '/about': 'Hakkımızda',
    '/shipping': 'Kargo Bilgileri',
    '/returns': 'İade & Değişim',
    '/payment': 'Ödeme Bilgileri',
    '/privacy': 'Gizlilik Politikası',
    '/terms': 'Kullanım Şartları',
    '/cookies': 'Çerez Politikası',
    '/account': 'Hesabım',
    '/dashboard': 'Hesap Paneli',
    '/account/settings': 'Hesap Ayarları',
    '/payment-success': 'Ödeme Başarılı',
    '/payment-fail': 'Ödeme Başarısız',
    '/order-tracking': 'Sipariş Takibi',
    '/reviews': 'Değerlendirmeler',
    '/admin': 'Admin Paneli'
  };

  // Direkt eşleşme varsa döndür
  if (pageNames[path]) {
    return pageNames[path];
  }

  // Dinamik sayfalar için pattern matching

  // Ürün detay sayfası: /product/123
  if (path.startsWith('/product/')) {
    const productId = path.split('/product/')[1];
    return `Ürün Detay (#${productId})`;
  }

  // Kategori sayfası: /category/elektronik
  if (path.startsWith('/category/')) {
    const categoryName = path.split('/category/')[1];
    const formattedCategory = decodeURIComponent(categoryName)
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return `📂 Kategori: ${formattedCategory}`;
  }

  // Sipariş detay: /orders/abc123
  if (path.startsWith('/orders/') && path.split('/').length > 2) {
    const orderId = path.split('/orders/')[1];
    return `📦 Sipariş Detay (#${orderId.substring(0, 8)}...)`;
  }

  // Bilinmeyen sayfa - URL'i formatla
  const segments = path.split('/').filter(s => s);
  if (segments.length > 0) {
    const formatted = segments
      .map(seg => seg.charAt(0).toUpperCase() + seg.slice(1))
      .join(' > ');
    return `📄 ${formatted}`;
  }

  return '📄 Bilinmeyen Sayfa';
}

// 🎨 Sayfa için ikon ve renk döndür
function getPageStyle(url) {
  const path = url.split('?')[0];

  if (path === '/') {
    return { color: '#E5332A', icon: '🏠' };
  } else if (path.startsWith('/product/')) {
    return { color: '#20C997', icon: '🛍️' };
  } else if (path === '/cart') {
    return { color: '#FFC107', icon: '🛒' };
  } else if (path === '/checkout' || path === '/payment-success') {
    return { color: '#28A745', icon: '💳' };
  } else if (path.startsWith('/category/')) {
    return { color: '#6f42c1', icon: '📂' };
  } else if (path === '/wishlist') {
    return { color: '#E83E8C', icon: '❤️' };
  } else if (path.startsWith('/orders')) {
    return { color: '#17A2B8', icon: '📦' };
  } else if (path === '/campaigns') {
    return { color: '#FD7E14', icon: '🎉' };
  } else if (path === '/account') {
    return { color: 'rgba(45, 60, 93, 1)', icon: '👤' }
  } else {
    return { color: '#6c757d', icon: '📄' };
  }
}

export function VisitorsTab({ refreshing, onRefresh, userTypeData, getTopViewedProducts, getProductCategoryViews }) {
  const [analytics, setAnalytics] = useState(null);
  const [hourlyData, setHourlyData] = useState([]);
  const [deviceData, setDeviceData] = useState({});
  const [browserData, setBrowserData] = useState({});
  const [realtimeCount, setRealtimeCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timeRange, setTimeRange] = useState(30);
  const [topProducts, setTopProducts] = useState([]);
  const [topProductsData, setTopProductsData] = useState([]);
  const [trafficSources, setTrafficSources] = useState([]);

  const GA4_PROPERTY_ID = '518039407'; // Kendi property ID'niz
  const GA4_URL = `https://analytics.google.com/analytics/web/#/p${GA4_PROPERTY_ID}/reports/intelligenthome`;

  const [allProducts, setAllProducts] = useState([]);

  useEffect(() => {
    loadGA4Data();

    // Realtime her 30 saniyede güncelle
    const interval = setInterval(loadRealtimeData, 30000);
    return () => clearInterval(interval);
  }, [timeRange]);

  const loadGA4Data = async () => {
    setLoading(true);
    try {
      console.log('🔄 GA4 verileri yükleniyor...');

      const [analyticsRes, hourlyRes, deviceRes, browserRes, realtimeRes, topProductsRes, productsRes, trafficRes] =
        await Promise.all([
          getVisitorAnalytics(timeRange),
          getHourlyDistribution(),
          getDeviceData(timeRange),
          getBrowserData(timeRange),
          getRealtimeVisitors(),
          getTopViewedProducts(timeRange, 10),
          getAllProducts(),
          getTrafficSources(timeRange)
        ]);

      console.log('📊 Analytics Response:', analyticsRes);
      console.log('⏰ Hourly Response:', hourlyRes);
      console.log('📱 Device Response:', deviceRes);
      console.log('🌐 Browser Response:', browserRes);
      console.log('🟢 Realtime Response:', realtimeRes);
      console.log('🛍️ Top Products Response:', topProductsRes);
      console.log('🌍 Traffic Sources Response:', trafficRes);

      if (analyticsRes.success) {
        // Günlük trend ekle
        const trendRes = await getDailyTrend(timeRange);
        if (trendRes.success) {
          setAnalytics({
            ...analyticsRes.analytics,
            dailyData: trendRes.dailyData
          });
        } else {
          setAnalytics(analyticsRes.analytics);
        }
      }

      if (hourlyRes.success) setHourlyData(hourlyRes.hourlyData);
      if (deviceRes.success) setDeviceData(deviceRes.devices);
      if (browserRes.success) setBrowserData(browserRes.browsers);
      if (realtimeRes.success) setRealtimeCount(realtimeRes.count);
      if (trafficRes.success) setTrafficSources(trafficRes.trafficSources);

      if (topProductsRes.success && productsRes.success) {
        const products = productsRes.products || [];
        setAllProducts(products);

        const enrichedProducts = topProductsRes.topProducts.map(topProduct => {
          // URL'den product ID'yi çıkar
          const productId = topProduct.productId;
          const fullProduct = products.find(p => p.id === productId);

          return {
            ...topProduct,
            productData: fullProduct || null
          };
        }).filter(p => p.productData); // Sadece bulduğumuz ürünleri göster

        setTopProducts(topProductsRes.topProducts);
        setTopProductsData(enrichedProducts);
        console.log('✅ Enriched products:', enrichedProducts);
      }

      console.log('✅ Tüm GA4 verileri yüklendi');

    } catch (error) {
      console.error('❌ GA4 veri hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadRealtimeData = async () => {
    const res = await getRealtimeVisitors();
    if (res.success) setRealtimeCount(res.count);
  };

  const exportData = () => {
    if (!analytics?.dailyData) return;

    const csv = [
      ['Tarih', 'Ziyaretçi Sayısı'],
      ...analytics.dailyData.map(d => [d.date, d.totalVisits || 0])
    ].map(row => row.join(',')).join('\n');

    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ziyaretci-raporu-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Kullanıcı tipi verileri (Firestore'dan)
  const registeredCount = userTypeData?.userTypes?.registered || 0;
  const guestCount = userTypeData?.userTypes?.guest || 0;
  const totalUsers = userTypeData?.total || 0;
  const conversionRate = userTypeData?.conversionRate || '0.0';
  const guestRate = totalUsers > 0
    ? ((guestCount / totalUsers) * 100).toFixed(1)
    : '0.0';

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div className="spinner" style={{
          width: '50px',
          height: '50px',
          border: '4px solid #e9ecef',
          borderTop: '4px solid #E5332A',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1.5rem'
        }}></div>
        <p style={{ color: '#868e96', fontSize: '16px', fontWeight: '600' }}>
          Ziyaretçi verileri yükleniyor...
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  const totalDevices = Object.values(deviceData).reduce((a, b) => a + b, 0);
  const totalBrowsers = Object.values(browserData).reduce((a, b) => a + b, 0);
  const totalTraffic = trafficSources.reduce((sum, t) => sum + t.sessions, 0);

  return (
    <div className="visitors-tab">
      <div className="page-header">
        <div>
          <h2 className="page-title">👥 Ziyaretçi Analitiği</h2>
          <p className="page-subtitle">
            Google Analytics 4 canlı verileri - {timeRange} günlük detaylı istatistikler
          </p>
        </div>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <select
            className="select"
            value={timeRange}
            onChange={(e) => setTimeRange(Number(e.target.value))}
            style={{ minWidth: '150px' }}
          >
            <option value={7}>📅 Son 7 Gün</option>
            <option value={30}>📅 Son 30 Gün</option>
            <option value={90}>📅 Son 90 Gün</option>
          </select>
          {/* ✅ Google Analytics Butonu */}
          <a
            href={GA4_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ga4"
            title="Google Analytics'te detaylı incele"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
              <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
            </svg>
            Google Analytics
          </a>
          <button className="btn btn-outline" onClick={exportData}>
            <Download size={18} />
            Dışa Aktar
          </button>
          <button className="btn btn-outline" onClick={loadGA4Data} disabled={loading}>
            <RefreshCw size={18} className={loading ? 'spin' : ''} />
            Yenile
          </button>
        </div>
      </div>

      {/* KPI Kartlar */}
      <div className="kpi-grid">
        <div className="kpi-card realtime-card">
          <div className="kpi-header">
            <span className="kpi-label">Şu An Çevrimiçi</span>
            <Activity size={20} className="realtime-icon" />
          </div>
          <div className="kpi-value">{realtimeCount}</div>
          <div className="kpi-footer">
            <span className="kpi-badge realtime">🟢 Canlı</span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-label">Toplam Ziyaret</span>
            <Eye size={20} />
          </div>
          <div className="kpi-value">{(analytics?.totalVisits || 0).toLocaleString('tr-TR')}</div>
          <div className="kpi-footer">
            <span className="kpi-trend positive">
              <TrendingUp size={14} />
              Son {timeRange} gün
            </span>
          </div>
        </div>

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-label">Günlük Ortalama</span>
            <BarChart3 size={20} />
          </div>
          <div className="kpi-value">{analytics?.avgVisitsPerDay || 0}</div>
          <div className="kpi-footer">
            <span className="kpi-info">ziyaret/gün</span>
          </div>
        </div>

        {/* Dönüşüm Oranı (Firestore) */}
        {totalUsers > 0 && (
          <div className="kpi-card">
            <div className="kpi-header">
              <span className="kpi-label">Dönüşüm Oranı</span>
              <Users size={20} />
            </div>
            <div className="kpi-value">{conversionRate}%</div>
            <div className="kpi-footer">
              <span className="kpi-info">
                {registeredCount} kayıtlı / {guestCount} misafir
              </span>
            </div>
          </div>
        )}

        <div className="kpi-card">
          <div className="kpi-header">
            <span className="kpi-label">En Yoğun Gün</span>
            <Award size={20} />
          </div>
          <div className="kpi-value" style={{ fontSize: '18px' }}>
            {analytics?.peakDay ?
              new Date(analytics.peakDay.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'))
                .toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' })
              : '-'
            }
          </div>
          <div className="kpi-footer">
            <span className="kpi-badge highlight">{analytics?.peakVisits || 0} ziyaret</span>
          </div>
        </div>
      </div>

      {/* Ana Grafikler */}
      <div className="charts-section">
        {/* Günlük Trend */}
        <div className="chart-card full-width">
          <div className="chart-header">
            <div>
              <h3>📈 Günlük Ziyaretçi Trendi</h3>
              <p className="chart-subtitle">Son {timeRange} günlük performans</p>
            </div>
          </div>
          <div className="chart-body">
            <DailyTrendChart data={analytics?.dailyData || []} />
          </div>
        </div>

        {/* Saatlik Dağılım */}
        <div className="chart-card">
          <div className="chart-header">
            <div>
              <h3>⏰ Saatlik Dağılım</h3>
              <p className="chart-subtitle">Bugünkü trafik yoğunluğu</p>
            </div>
          </div>
          <div className="chart-body">
            <HourlyChart data={hourlyData} />
          </div>
        </div>

        {/* Kullanıcı Tipi Dağılımı (Firestore) */}
        {totalUsers > 0 && (
          <div className="chart-card">
            <div className="chart-header">
              <div>
                <h3>👤 Kullanıcı Tipi</h3>
                <p className="chart-subtitle">Misafir vs Kayıtlı</p>
              </div>
            </div>
            <div className="chart-body">
              <div className="user-type-chart">
                <div className="donut-chart">
                  <svg viewBox="0 0 100 100" style={{ transform: 'rotate(-90deg)' }}>
                    <circle cx="50" cy="50" r="40" fill="none" stroke="#e9ecef" strokeWidth="20" />
                    <circle
                      cx="50"
                      cy="50"
                      r="40"
                      fill="none"
                      stroke="#20C997"
                      strokeWidth="20"
                      strokeDasharray={`${(registeredCount / totalUsers) * 251.2} 251.2`}
                    />
                  </svg>
                  <div className="donut-center">
                    <span className="donut-value">{conversionRate}%</span>
                    <span className="donut-label">Kayıtlı</span>
                  </div>
                </div>
                <div className="user-type-legend">
                  <div className="legend-item">
                    <span className="legend-color" style={{ background: '#20C997' }}></span>
                    <span className="legend-text">Kayıtlı: {registeredCount} ({conversionRate}%)</span>
                  </div>
                  <div className="legend-item">
                    <span className="legend-color" style={{ background: '#e9ecef' }}></span>
                    <span className="legend-text">Misafir: {guestCount} ({guestRate}%)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ YENİ: Trafik Kaynakları */}
        <div className="chart-card">
          <div className="chart-header">
            <div>
              <h3>🌍 Trafik Kaynakları</h3>
              <p className="chart-subtitle">Ziyaretçiler nereden geliyor</p>
            </div>
          </div>
          <div className="chart-body">
            {trafficSources.length > 0 ? (
              <TrafficSourcesChart sources={trafficSources} />
            ) : (
              <div className="empty-state">
                <Activity size={48} color="#dee2e6" />
                <p>Henüz trafik kaynağı verisi yok</p>
              </div>
            )}
          </div>
        </div>

        {/* ✅ YENİ: En Çok Görüntülenen Ürünler */}
        <div className="chart-card full-width">
          <div className="chart-header">
            <div>
              <h3>En Çok Görüntülenen Ürünler</h3>
              <p className="chart-subtitle">Son {timeRange} günlük ürün detay sayfası ziyaretleri</p>
            </div>
          </div>
          <div className="chart-body">
            {topProductsData.length > 0 ? (
              <TopProductsGrid
                products={topProductsData}
                timeRange={timeRange}
                campaigns={[]} // AdminPanel'den campaigns prop'u varsa buraya ekleyin
              />
            ) : (
              <div className="empty-state">
                <ShoppingBag size={48} color="#dee2e6" />
                <p>Henüz ürün görüntüleme verisi yok</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .visitors-tab {
          padding: 0;
        }

        .page-subtitle {
          margin: 0.5rem 0 0 0;
          font-size: 14px;
          color: #868e96;
          font-weight: 500;
        }

        .kpi-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1.25rem;
          margin-bottom: 2rem;
        }

        .kpi-card {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
          border: 2px solid #e9ecef;
          transition: all 0.3s ease;
        }

        .kpi-card:hover {
          border-color: #E5332A;
          box-shadow: 0 4px 12px rgba(229, 51, 42, 0.1);
          transform: translateY(-2px);
        }

        .realtime-card {
          background: linear-gradient(135deg, #E5332A 0%, #ff5a50 100%);
          border: none;
          color: white;
        }

        .realtime-card .kpi-label,
        .realtime-card .kpi-value,
        .realtime-card .kpi-badge {
          color: white;
        }

        .kpi-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .kpi-label {
          font-size: 13px;
          font-weight: 600;
          color: #868e96;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .kpi-header svg {
          color: #E5332A;
        }

        .realtime-card .kpi-header svg {
          color: white;
        }

        .realtime-icon {
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        .kpi-value {
          font-size: 32px;
          font-weight: 700;
          color: #2B2B2B;
          margin-bottom: 0.5rem;
          line-height: 1;
        }

        .kpi-footer {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .kpi-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.25rem;
          padding: 0.25rem 0.75rem;
          background: #f8f9fa;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          color: #495057;
        }

        .kpi-badge.realtime {
          background: rgba(255, 255, 255, 0.2);
          color: white;
        }

        .kpi-badge.highlight {
          background: #E5332A;
          color: white;
        }

        .kpi-trend {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-size: 12px;
          font-weight: 600;
        }

        .kpi-trend.positive {
          color: #20C997;
        }

        .kpi-info {
          font-size: 12px;
          color: #868e96;
        }

        /* ✅ Google Analytics Butonu */
        .btn-ga4 {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.625rem 1rem;
          background: linear-gradient(135deg, #E37400, #F9AB00);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          text-decoration: none;
          box-shadow: 0 2px 8px rgba(227, 116, 0, 0.2);
        }

        .btn-ga4:hover {
          background: linear-gradient(135deg, #C96100, #E37400);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(227, 116, 0, 0.3);
        }

        .btn-ga4 svg {
          animation: rotate 3s linear infinite;
        }

        @keyframes rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .btn-ga4:hover svg {
          animation: rotate 1s linear infinite;
        }

        .charts-section {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
        }

        .chart-card {
          background: white;
          border-radius: 12px;
          border: 2px solid #e9ecef;
          overflow: hidden;
        }

        .chart-card.full-width {
          grid-column: 1 / -1;
        }

        .chart-header {
          padding: 1.5rem;
          border-bottom: 2px solid #e9ecef;
          background: #f8f9fa;
        }

        .chart-header h3 {
          margin: 0 0 0.25rem 0;
          font-size: 16px;
          font-weight: 700;
          color: #2B2B2B;
        }

        .chart-subtitle {
          margin: 0;
          font-size: 13px;
          color: #868e96;
          font-weight: 500;
        }

        .chart-body {
          padding: 2rem;
        }

        .empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3rem 1rem;
          text-align: center;
          color: #868e96;
        }

        .empty-state svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-state p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
        }

        .device-stats, .browser-stats {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .stat-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 14px;
          font-weight: 600;
        }

        .stat-icon {
          font-size: 20px;
        }

        .stat-name {
          flex: 1;
          color: #495057;
        }

        .stat-value {
          color: #E5332A;
          font-weight: 700;
        }

        .stat-bar {
          height: 10px;
          background: #e9ecef;
          border-radius: 5px;
          overflow: hidden;
        }

        .stat-fill {
          height: 100%;
          transition: width 0.5s ease;
          border-radius: 5px;
        }

        .stat-percentage {
          font-size: 12px;
          color: #868e96;
          font-weight: 600;
        }

        .user-type-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2rem;
        }

        .donut-chart {
          position: relative;
          width: 150px;
          height: 150px;
        }

        .donut-chart svg {
          width: 100%;
          height: 100%;
        }

        .donut-center {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
        }

        .donut-value {
          display: block;
          font-size: 16px;
          font-weight: 700;
          color: #2B2B2B;
        }

        .donut-label {
          display: block;
          font-size: 12px;
          color: #868e96;
          margin-top: 0.25rem;
        }

        .user-type-legend {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          width: 100%;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .legend-color {
          width: 16px;
          height: 16px;
          border-radius: 4px;
        }

        .legend-text {
          font-size: 14px;
          color: #495057;
          font-weight: 500;
        }

        .rank-badge {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          font-weight: 700;
          font-size: 16px;
        }

        .rank-1 {
          background: linear-gradient(135deg, #E5332A, #ff5a50);
          color: white;
        }

        .rank-2 {
          background: linear-gradient(135deg, #FFC107, #FFD700);
          color: white;
        }

        .rank-3 {
          background: linear-gradient(135deg, #20C997, #28E5B0);
          color: white;
        }

        .rank-badge:not(.rank-1):not(.rank-2):not(.rank-3) {
          background: #e9ecef;
          color: #6c757d;
        }

        @media (max-width: 1200px) {
          .charts-section {
            grid-template-columns: 1fr;
          }
          
          .kpi-grid {
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          }
        }

        @media (max-width: 768px) {
          .page-bar {
            width: 100%;
            grid-column: 1 / -1;
          }
          
          .kpi-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
    </div>
  );
}

function TrafficSourcesChart({ sources }) {
  if (!sources || sources.length === 0) {
    return (
      <div className="empty-chart">
        <Activity size={48} color="#dee2e6" />
        <p>Henüz trafik kaynağı verisi yok</p>
      </div>
    );
  }

  const totalSessions = sources.reduce((sum, s) => sum + s.sessions, 0);

  // Kaynak türüne göre icon ve renk
  const getSourceStyle = (source) => {
    const lowerSource = source.toLowerCase();

    if (lowerSource === 'google' || lowerSource.includes('google')) {
      return { icon: '🔍', color: '#4285F4', name: 'Google' };
    }
    if (lowerSource === '(direct)' || lowerSource === 'direct') {
      return { icon: '🔗', color: '#868e96', name: 'Direct' };
    }
    if (lowerSource.includes('facebook') || lowerSource.includes('fb')) {
      return { icon: '📘', color: '#1877F2', name: 'Facebook' };
    }
    if (lowerSource.includes('instagram') || lowerSource.includes('ig')) {
      return { icon: '📸', color: '#E4405F', name: 'Instagram' };
    }
    if (lowerSource.includes('twitter') || lowerSource.includes('x.com')) {
      return { icon: '🐦', color: '#1DA1F2', name: 'Twitter/X' };
    }
    if (lowerSource.includes('youtube') || lowerSource.includes('yt')) {
      return { icon: '📺', color: '#FF0000', name: 'YouTube' };
    }
    if (lowerSource.includes('linkedin')) {
      return { icon: '💼', color: '#0A66C2', name: 'LinkedIn' };
    }
    if (lowerSource.includes('whatsapp')) {
      return { icon: '💬', color: '#25D366', name: 'WhatsApp' };
    }
    if (lowerSource.includes('tiktok')) {
      return { icon: '🎵', color: '#000000', name: 'TikTok' };
    }
    if (lowerSource === '(not set)' || lowerSource === 'not set') {
      return { icon: '❓', color: '#adb5bd', name: 'Bilinmeyen' };
    }

    // Referral veya diğer
    return { icon: '🌐', color: '#20C997', name: source };
  };

  return (
    <div className="traffic-sources-chart">
      <div className="sources-list">
        {sources.map((source, index) => {
          const percentage = ((source.sessions / totalSessions) * 100).toFixed(1);
          const style = getSourceStyle(source.source);

          return (
            <div key={index} className="source-item">
              <div className="source-header">
                <span className="source-icon">{style.icon}</span>
                <span className="source-name">{style.name}</span>
                <div className="source-stats">
                  <span className="source-sessions">{source.sessions.toLocaleString('tr-TR')}</span>
                  <span className="source-label">oturum</span>
                </div>
              </div>

              <div className="source-bar">
                <div
                  className="source-fill"
                  style={{
                    width: `${percentage}%`,
                    background: style.color
                  }}
                />
              </div>

              <div className="source-footer">
                <span className="source-percentage">{percentage}% trafik</span>
                <span className="source-users">{source.users.toLocaleString('tr-TR')} kullanıcı</span>
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .traffic-sources-chart {
          width: 100%;
        }

        .sources-list {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }

        .source-item {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .source-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .source-icon {
          font-size: 20px;
          flex-shrink: 0;
        }

        .source-name {
          flex: 1;
          font-size: 14px;
          font-weight: 600;
          color: #2B2B2B;
        }

        .source-stats {
          display: flex;
          align-items: baseline;
          gap: 0.35rem;
        }

        .source-sessions {
          font-size: 16px;
          font-weight: 700;
          color: #E5332A;
        }

        .source-label {
          font-size: 11px;
          color: #868e96;
          font-weight: 500;
        }

        .source-bar {
          height: 10px;
          background: #e9ecef;
          border-radius: 5px;
          overflow: hidden;
        }

        .source-fill {
          height: 100%;
          transition: width 0.5s ease;
          border-radius: 5px;
        }

        .source-footer {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
        }

        .source-percentage {
          color: #495057;
          font-weight: 600;
        }

        .source-users {
          color: #868e96;
        }

        .empty-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 3rem 1rem;
          color: #868e96;
        }

        .empty-chart svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-chart p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .sources-list {
            gap: 1rem;
          }

          .source-header {
            gap: 0.5rem;
          }

          .source-icon {
            font-size: 18px;
          }

          .source-name {
            font-size: 13px;
          }

          .source-sessions {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
}

function TopProductsGrid({ products, timeRange, campaigns }) {
  if (!products || products.length === 0) {
    return (
      <div className="empty-chart">
        <ShoppingBag size={48} color="#dee2e6" />
        <p>Henüz ürün görüntüleme verisi yok</p>
      </div>
    );
  }

  return (
    <div className="top-products-container">
      <div className="top-products-grid">
        {products.map((item, index) => {
          const product = item.productData;
          const avgMinutes = (parseFloat(item.avgDuration) / 60).toFixed(1);

          return (
            <div key={index} className="top-product-wrapper">
              {/* ✅ Analytics Product Card */}
              <AnalyticsProductCard
                product={product}
                campaigns={campaigns}
                rank={index + 1}
              />

              {/* Analytics Stats Overlay */}
              <div className="product-analytics-overlay">
                <div className="analytics-stat">
                  <Eye size={14} />
                  <span className="stat-value">{item.views.toLocaleString('tr-TR')}</span>
                  <span className="stat-label">görüntülenme</span>
                </div>

                <div className="analytics-stat">
                  <Clock size={14} />
                  <span className="stat-value">{avgMinutes}</span>
                  <span className="stat-label">dk ort. süre</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .top-products-container {
          width: 100%;
        }

        .top-products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 1.5rem;
          padding: 1rem 0;
        }

        .top-product-wrapper {
          position: relative;
          height: 100%;
        }

        /* Analytics Overlay */
        .product-analytics-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.85), transparent);
          padding: 12px;
          display: flex;
          gap: 1rem;
          backdrop-filter: blur(4px);
          border-radius: 0 0 12px 12px;
          opacity: 0;
          transition: opacity 0.3s;
          pointer-events: none;
          z-index: 5;
        }

        .top-product-wrapper:hover .product-analytics-overlay {
          opacity: 1;
        }

        .analytics-stat {
          display: flex;
          align-items: center;
          gap: 0.35rem;
          color: white;
          font-size: 11px;
        }

        .analytics-stat svg {
          color: #06d6a0;
          flex-shrink: 0;
        }

        .stat-value {
          font-weight: 700;
          font-size: 12px;
        }

        .stat-label {
          color: rgba(255,255,255,0.8);
          font-size: 10px;
        }

        .empty-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 1rem;
          color: #868e96;
        }

        .empty-chart svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-chart p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
        }

        /* Responsive */
        @media (max-width: 1400px) {
          .top-products-grid {
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          }
        }

        @media (max-width: 1200px) {
          .top-products-grid {
            grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
            gap: 1rem;
          }
        }

        @media (max-width: 768px) {
          .top-products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.75rem;
          }

          .product-analytics-overlay {
            opacity: 1;
            padding: 8px;
            flex-direction: column;
            gap: 0.5rem;
          }

          .analytics-stat {
            font-size: 10px;
          }

          .stat-value {
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .top-products-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

// Günlük Trend Chart
function DailyTrendChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div className="empty-chart">
        <BarChart3 size={48} color="#dee2e6" />
        <p>Henüz günlük veri bulunmuyor</p>
      </div>
    );
  }

  // Tarihe göre artan sıralama (eski -> yeni)
  const sortedData = [...data].sort((a, b) => {
    return new Date(a.date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')) -
      new Date(b.date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
  });

  const maxVisits = Math.max(...sortedData.map(d => d.totalVisits || 0), 1);

  return (
    <div className="daily-trend-chart">
      <div className="chart-bars">
        {sortedData.map((day, index) => {
          const height = Math.max((day.totalVisits / maxVisits) * 100, 2);
          const date = new Date(day.date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'));
          const dayName = date.toLocaleDateString('tr-TR', { weekday: 'short' });
          const dayNum = date.getDate();
          const monthName = date.toLocaleDateString('tr-TR', { month: 'short' });

          return (
            <div key={index} className="bar-wrapper">
              <div
                className="bar"
                style={{ height: `${height}%` }}
                title={`${date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}: ${day.totalVisits} ziyaret`}
              >
                {day.totalVisits > 0 && <span className="bar-value">{day.totalVisits}</span>}
              </div>
              <div className="bar-label-group">
                <span className="bar-label-day">{dayNum}</span>
                <span className="bar-label-month">{monthName}</span>
                <span className="bar-label-weekday">{dayName}</span>
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .daily-trend-chart {
          height: 340px;
        }

        .empty-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 340px;
          color: #868e96;
        }

        .empty-chart svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-chart p {
          margin: 0;
          font-size: 14px;
        }

        .chart-bars {
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;
          height: calc(100% - 55px);
          gap: 4px;
          padding-bottom: 0;
          overflow-x: auto;
          padding: 0 1rem;
        }

        .chart-bars::-webkit-scrollbar {
          height: 6px;
        }

        .chart-bars::-webkit-scrollbar-track {
          background: #f1f3f5;
          border-radius: 3px;
        }

        .chart-bars::-webkit-scrollbar-thumb {
          background: #E5332A;
          border-radius: 3px;
        }

        .bar-wrapper {
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          justify-content: flex-end;
          min-width: 35px;
        }

        .bar {
          width: 100%;
          max-width: 35px;
          background: linear-gradient(180deg, #E5332A 0%, #ff5a50 100%);
          border-radius: 6px 6px 0 0;
          transition: all 0.3s ease;
          position: relative;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding-top: 0.5rem;
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(229, 51, 42, 0.2);
        }

        .bar:hover {
          background: linear-gradient(180deg, #d42a22 0%, #e54840 100%);
          transform: translateY(-4px);
          box-shadow: 0 4px 8px rgba(229, 51, 42, 0.3);
        }

        .bar-value {
          font-size: 10px;
          font-weight: 700;
          color: white;
          text-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }

        .bar-label-group {
          margin-top: 0.75rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.15rem;
        }

        .bar-label-day {
          font-size: 14px;
          color: #2B2B2B;
          font-weight: 700;
        }

        .bar-label-month {
          font-size: 9px;
          color: #E5332A;
          font-weight: 600;
          text-transform: uppercase;
        }

        .bar-label-weekday {
          font-size: 9px;
          color: #868e96;
          font-weight: 500;
          text-transform: uppercase;
        }

        @media (max-width: 768px) {
          .chart-bars {
            gap: 3px;
            padding: 0 0.5rem;
          }

          .bar-wrapper {
            min-width: 28px;
          }

          .bar {
            max-width: 28px;
          }

          .bar-value {
            font-size: 9px;
          }

          .bar-label-day {
            font-size: 12px;
          }

          .bar-label-month {
            font-size: 8px;
          }

          .bar-label-weekday {
            font-size: 8px;
          }
        }
      `}</style>
    </div>
  );
}

// Saatlik Chart
function HourlyChart({ data }) {
  if (!data || data.length === 0 || data.every(v => v === 0)) {
    return (
      <div className="empty-chart">
        <Clock size={48} color="#dee2e6" />
        <p>Bugün henüz ziyaret yok</p>
      </div>
    );
  }

  const maxVisits = Math.max(...data, 1);

  return (
    <div className="hourly-chart">
      <div className="hourly-bars">
        {data.map((visits, hour) => {
          const height = Math.max((visits / maxVisits) * 100, 2);

          return (
            <div key={hour} className="hourly-wrapper">
              <div
                className="hourly-bar"
                style={{ height: `${height}%` }}
                title={`${hour}:00 - ${visits} ziyaret`}
              >
                {visits > 0 && <span className="hourly-value">{visits}</span>}
              </div>
              <span className="hourly-label">{hour}</span>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        .hourly-chart {
          height: 220px;
        }

        .empty-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 220px;
          color: #868e96;
        }

        .empty-chart svg {
          margin-bottom: 1rem;
          opacity: 0.5;
        }

        .empty-chart p {
          margin: 0;
          font-size: 14px;
        }

        .hourly-bars {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          height: calc(100% - 25px);
          gap: 2px;
          padding-bottom: 0;
        }

        .hourly-wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          justify-content: flex-end;
        }

        .hourly-bar {
          width: 100%;
          max-width: 24px;
          background: linear-gradient(180deg, #20C997 0%, #28E5B0 100%);
          border-radius: 4px 4px 0 0;
          transition: all 0.3s ease;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding-top: 0.25rem;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(32, 201, 151, 0.2);
          position: relative;
        }

        .hourly-bar:hover {
          background: linear-gradient(180deg, #1aa17a 0%, #20C997 100%);
          transform: translateY(-2px);
          box-shadow: 0 2px 6px rgba(32, 201, 151, 0.3);
        }

        .hourly-value {
          font-size: 10px;
          font-weight: 700;
          color: white;
          text-shadow: 0 1px 2px rgba(0,0,0,0.2);
        }

        .hourly-label {
          margin-top: 0.5rem;
          font-size: 10px;
          color: #868e96;
          font-weight: 500;
          order: 2;
        }
      `}</style>
    </div>
  );
}

// CUSTOMERS TAB  
export function CustomersTab({ customers = [], onCustomerClick }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('recent');

  const filteredCustomers = customers
    .filter(customer => {
      const search = searchTerm.toLowerCase();
      return (
        customer.name?.toLowerCase().includes(search) ||
        customer.email?.toLowerCase().includes(search) ||
        customer.phone?.toLowerCase().includes(search)
      );
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'recent':
          // 🔧 Timestamp düzeltmesi
          const dateA = a.lastOrderDate?.seconds
            ? new Date(a.lastOrderDate.seconds * 1000)
            : new Date(a.lastOrderDate || 0);
          const dateB = b.lastOrderDate?.seconds
            ? new Date(b.lastOrderDate.seconds * 1000)
            : new Date(b.lastOrderDate || 0);
          return dateB - dateA;
        case 'name':
          return (a.name || '').localeCompare(b.name || '');
        case 'orders':
          return (b.totalOrders || 0) - (a.totalOrders || 0);
        case 'spent':
          return (b.totalSpent || 0) - (a.totalSpent || 0);
        default:
          return 0;
      }
    });

  const customerStats = {
    total: customers.length,
    active: customers.filter(c => c.status === 'active').length,
    vip: customers.filter(c => (c.totalOrders || 0) >= 10).length,
    totalRevenue: customers.reduce((sum, c) => sum + (c.totalSpent || 0), 0),
    avgOrderValue: customers.length > 0
      ? customers.reduce((sum, c) => sum + (c.totalSpent || 0), 0) / customers.length
      : 0
  };

  // 🔧 Tarih formatlama yardımcı fonksiyonu
  const formatDate = (dateField) => {
    if (!dateField) return null;

    // Firestore Timestamp objesi
    if (dateField.seconds) {
      return new Date(dateField.seconds * 1000);
    }

    // Normal Date objesi veya string
    return new Date(dateField);
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">👥 Müşteri Yönetimi</h2>
      </div>

      {/* Customer Stats */}
      <div className="stats-grid">
        <div className="stat-card" style={{ borderColor: '#2196F3' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Müşteri</p>
              <p className="stat-value">{customerStats.total}</p>
              <p className="stat-subtext">{customerStats.active} aktif</p>
            </div>
            <div className="stat-icon" style={{ background: '#2196F320' }}>
              <Users size={26} color="#2196F3" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#FFD700' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">VIP Müşteri</p>
              <p className="stat-value">{customerStats.vip}</p>
              <p className="stat-subtext">10+ sipariş</p>
            </div>
            <div className="stat-icon" style={{ background: '#FFD70020' }}>
              <Award size={26} color="#FFD700" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#4CAF50' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Ciro</p>
              <p className="stat-value">{customerStats.totalRevenue.toFixed(0)}₺</p>
              <p className="stat-subtext">Müşterilerden</p>
            </div>
            <div className="stat-icon" style={{ background: '#4CAF5020' }}>
              <DollarSign size={26} color="#4CAF50" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#9C27B0' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Ort. Sepet Tutarı</p>
              <p className="stat-value">{customerStats.avgOrderValue.toFixed(0)}₺</p>
              <p className="stat-subtext">Müşteri başı</p>
            </div>
            <div className="stat-icon" style={{ background: '#9C27B020' }}>
              <TrendingUp size={26} color="#9C27B0" />
            </div>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="toolbar">
        <div className="search-bar">
          <Search size={18} />
          <input
            type="text"
            placeholder="Müşteri adı, email veya telefon ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="toolbar-divider"></div>

        <select className="select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="recent">Son Siparişe Göre</option>
          <option value="name">İsme Göre</option>
          <option value="orders">Sipariş Sayısına Göre</option>
          <option value="spent">Harcamaya Göre</option>
        </select>
      </div>

      {/* Customers Grid */}
      <div className="customers-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '1.5rem'
      }}>
        {filteredCustomers.length === 0 ? (
          <div className="empty-state">
            <Users size={64} color="#E5332A" />
            <p>Müşteri bulunamadı</p>
          </div>
        ) : (
          filteredCustomers.map(customer => {
            const lastOrderDate = formatDate(customer.lastOrderDate);

            return (
              <div
                key={customer.id}
                className="customer-card"
                onClick={() => onCustomerClick(customer)}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  border: '2px solid #e9ecef',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              >
                <div className="customer-avatar" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: (customer.totalOrders || 0) >= 10
                    ? 'linear-gradient(135deg, #FFD700, #FFA500)'
                    : 'linear-gradient(135deg, #E5332A, #ff6b6b)',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  fontWeight: '700',
                  margin: '0 auto 1rem'
                }}>
                  {customer.name?.charAt(0).toUpperCase() || '?'}
                </div>

                <div className="customer-info" style={{
                  textAlign: 'center',
                  marginBottom: '1rem'
                }}>
                  <h3 style={{ margin: '0 0 0.5rem', fontSize: '18px' }}>
                    {customer.name || 'İsimsiz Müşteri'}
                  </h3>
                  {(customer.totalOrders || 0) >= 10 && (
                    <span className="vip-badge" style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.25rem',
                      background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                      color: 'white',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '700'
                    }}>
                      <Award size={14} /> VIP
                    </span>
                  )}
                </div>

                <div className="customer-contact" style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.5rem',
                  marginBottom: '1rem'
                }}>
                  <div className="contact-item" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: '#666',
                    fontSize: '13px',
                    wordBreak: 'break-word'
                  }}>
                    <Mail size={14} style={{ flexShrink: 0 }} />
                    <span>{customer.email || '-'}</span>
                  </div>
                  {customer.phone && (
                    <div className="contact-item" style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: '#666',
                      fontSize: '13px'
                    }}>
                      <Phone size={14} style={{ flexShrink: 0 }} />
                      <span>{customer.phone}</span>
                    </div>
                  )}
                </div>

                <div className="customer-stats" style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '1rem',
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  <div className="stat-item" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <ShoppingCart size={16} color="#2196F3" />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <strong style={{ fontSize: '16px' }}>{customer.totalOrders || 0}</strong>
                      <span style={{ fontSize: '11px', color: '#868e96' }}>Sipariş</span>
                    </div>
                  </div>
                  <div className="stat-item" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <DollarSign size={16} color="#4CAF50" />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <strong style={{ fontSize: '16px' }}>
                        {(customer.totalSpent || 0).toFixed(0)}₺
                      </strong>
                      <span style={{ fontSize: '11px', color: '#868e96' }}>Toplam</span>
                    </div>
                  </div>
                </div>

                {lastOrderDate && (
                  <div className="customer-footer" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem',
                    color: '#868e96',
                    fontSize: '12px',
                    marginTop: '1rem',
                    paddingTop: '1rem',
                    borderTop: '1px solid #f0f0f0'
                  }}>
                    <Clock size={14} />
                    <span>
                      Son: {lastOrderDate.toLocaleDateString('tr-TR', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </span>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export function ReportsTab({ products, campaigns, orders = [] }) {
  const [period, setPeriod] = useState('month');
  const [reportType, setReportType] = useState('overview');

  // 📊 Finansal Hesaplamalar
  const calculateFinancials = () => {
    const now = new Date();
    let startDate;

    switch (period) {
      case 'day':
        startDate = new Date(now.setHours(0, 0, 0, 0));
        break;
      case 'week':
        startDate = new Date(now.setDate(now.getDate() - 7));
        break;
      case 'month':
        startDate = new Date(now.setMonth(now.getMonth() - 1));
        break;
      case 'year':
        startDate = new Date(now.setFullYear(now.getFullYear() - 1));
        break;
      default:
        startDate = new Date(0);
    }

    const relevantOrders = orders.filter(o =>
      new Date(o.createdAt) >= startDate && o.status !== 'cancelled'
    );

    const revenue = relevantOrders.reduce((sum, o) => sum + (o.total || 0), 0);
    const cost = relevantOrders.reduce((sum, o) => {
      const orderCost = (o.items || []).reduce((itemSum, item) => {
        const product = products.find(p => p.id === item.productId);
        return itemSum + ((product?.cost || product?.price * 0.6 || 0) * item.quantity);
      }, 0);
      return sum + orderCost;
    }, 0);
    const profit = revenue - cost;
    const margin = revenue > 0 ? ((profit / revenue) * 100).toFixed(1) : 0;

    return {
      revenue,
      cost,
      profit,
      margin,
      orderCount: relevantOrders.length,
      avgOrderValue: relevantOrders.length > 0 ? revenue / relevantOrders.length : 0
    };
  };

  // 📈 Kategori İstatistikleri
  const calculateCategoryStats = () => {
    const categoryStats = {};
    products.forEach(p => {
      const cat = p.category || 'Diğer';
      if (!categoryStats[cat]) {
        categoryStats[cat] = {
          count: 0,
          value: 0,
          sales: 0,
          stock: 0
        };
      }
      categoryStats[cat].count++;
      categoryStats[cat].value += (p.currentPrice || p.price) * p.stock;
      categoryStats[cat].sales += p.sales || 0;
      categoryStats[cat].stock += p.stock || 0;
    });
    return categoryStats;
  };

  // 🏆 En Çok Satan Ürünler
  const getTopProducts = () => {
    return [...products]
      .sort((a, b) => (b.sales || 0) - (a.sales || 0))
      .slice(0, 10);
  };

  // 📉 Düşük Stok Ürünleri
  const getLowStockProducts = () => {
    return products
      .filter(p => p.stock < (p.minStock || 5))
      .sort((a, b) => a.stock - b.stock);
  };

  // 💎 En Değerli Müşteriler
  const getTopCustomers = () => {
    const customerStats = {};
    orders.forEach(order => {
      const customerId = order.customerId || order.customerEmail || order.email;
      if (!customerId) return;

      if (!customerStats[customerId]) {
        customerStats[customerId] = {
          name: order.customerName || order.shippingAddress?.name || 'Misafir',
          email: order.customerEmail || order.email,
          totalSpent: 0,
          orderCount: 0
        };
      }
      customerStats[customerId].totalSpent += order.total || 0;
      customerStats[customerId].orderCount++;
    });

    return Object.values(customerStats)
      .sort((a, b) => b.totalSpent - a.totalSpent)
      .slice(0, 10);
  };

  // 📅 Kampanya Performansı
  const getCampaignPerformance = () => {
    return campaigns.map(campaign => {
      const isActive = new Date(campaign.endDate) > new Date();
      const discountedProducts = products.filter(p => p.discount > 0);

      return {
        ...campaign,
        isActive,
        affectedProducts: discountedProducts.length,
        totalSales: discountedProducts.reduce((sum, p) => sum + (p.sales || 0), 0)
      };
    });
  };

  // 📊 CSV Export
  const exportToCSV = () => {
    let csv = '';
    const stats = calculateFinancials();
    const categoryStats = calculateCategoryStats();

    if (reportType === 'overview') {
      csv = [
        ['E-TİCARET RAPORU', '', '', ''],
        ['Tarih:', new Date().toLocaleDateString('tr-TR'), '', ''],
        ['Dönem:', period === 'day' ? 'Bugün' : period === 'week' ? 'Bu Hafta' : period === 'month' ? 'Bu Ay' : 'Bu Yıl', '', ''],
        ['', '', '', ''],
        ['FİNANSAL ÖZET', '', '', ''],
        ['Gelir', stats.revenue.toFixed(2) + '₺', '', ''],
        ['Maliyet', stats.cost.toFixed(2) + '₺', '', ''],
        ['Net Kar', stats.profit.toFixed(2) + '₺', '', ''],
        ['Kar Marjı', '%' + stats.margin, '', ''],
        ['Sipariş Sayısı', stats.orderCount, '', ''],
        ['Ort. Sipariş Değeri', stats.avgOrderValue.toFixed(2) + '₺', '', ''],
        ['', '', '', ''],
        ['KATEGORİ ANALİZİ', '', '', ''],
        ['Kategori', 'Ürün Sayısı', 'Toplam Değer', 'Satışlar'],
        ...Object.entries(categoryStats).map(([cat, data]) => [
          cat,
          data.count,
          data.value.toFixed(2) + '₺',
          data.sales
        ])
      ];
    } else if (reportType === 'products') {
      csv = [
        ['ÜRÜN RAPORU', '', '', '', '', ''],
        ['SKU', 'Ürün Adı', 'Kategori', 'Fiyat', 'Stok', 'Satışlar'],
        ...products.map(p => [
          p.sku || '-',
          p.name,
          p.category || '-',
          (p.currentPrice || p.price).toFixed(2) + '₺',
          p.stock,
          p.sales || 0
        ])
      ];
    } else if (reportType === 'orders') {
      csv = [
        ['SİPARİŞ RAPORU', '', '', '', ''],
        ['Sipariş No', 'Müşteri', 'Tutar', 'Durum', 'Tarih'],
        ...orders.map(o => [
          o.orderNumber || o.id,
          o.customerName || 'Misafir',
          o.total.toFixed(2) + '₺',
          o.status,
          new Date(o.createdAt).toLocaleDateString('tr-TR')
        ])
      ];
    }

    const csvContent = csv.map(row => row.join(',')).join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `rapor-${reportType}-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const stats = calculateFinancials();
  const categoryStats = calculateCategoryStats();
  const topProducts = getTopProducts();
  const lowStockProducts = getLowStockProducts();
  const topCustomers = getTopCustomers();
  const campaignPerformance = getCampaignPerformance();

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">📊 Raporlar & Analizler</h2>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <select className="select" value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="day">Bugün</option>
            <option value="week">Bu Hafta</option>
            <option value="month">Bu Ay</option>
            <option value="year">Bu Yıl</option>
          </select>
          <select className="select" value={reportType} onChange={(e) => setReportType(e.target.value)}>
            <option value="overview">Genel Bakış</option>
            <option value="products">Ürün Raporu</option>
            <option value="orders">Sipariş Raporu</option>
          </select>
          <button className="btn btn-primary" onClick={exportToCSV}>
            <Download size={18} /> CSV İndir
          </button>
        </div>
      </div>

      {/* Finansal İstatistikler */}
      <div className="stats-grid">
        <div className="stat-card" style={{ borderColor: '#4CAF50' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Gelir</p>
              <p className="stat-value">{stats.revenue.toFixed(0)}₺</p>
              <p className="stat-subtext">{stats.orderCount} sipariş</p>
            </div>
            <div className="stat-icon" style={{ background: '#4CAF5020' }}>
              <TrendingUp size={26} color="#4CAF50" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#E5332A' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Toplam Maliyet</p>
              <p className="stat-value">{stats.cost.toFixed(0)}₺</p>
              <p className="stat-subtext">Ürün maliyeti</p>
            </div>
            <div className="stat-icon" style={{ background: '#E5332A20' }}>
              <TrendingDown size={26} color="#E5332A" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#2196F3' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Net Kar</p>
              <p className="stat-value">{stats.profit.toFixed(0)}₺</p>
              <p className="stat-subtext">Kar marjı: %{stats.margin}</p>
            </div>
            <div className="stat-icon" style={{ background: '#2196F320' }}>
              <DollarSign size={26} color="#2196F3" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#9C27B0' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Ort. Sipariş Değeri</p>
              <p className="stat-value">{stats.avgOrderValue.toFixed(0)}₺</p>
              <p className="stat-subtext">Sipariş başına</p>
            </div>
            <div className="stat-icon" style={{ background: '#9C27B020' }}>
              <BarChart3 size={26} color="#9C27B0" />
            </div>
          </div>
        </div>
      </div>

      <div className="analytics-grid">
        {/* Kategori Analizi */}
        <div className="analytics-card">
          <h3>📈 Kategori Bazlı Dağılım</h3>
          <div className="chart-list">
            {Object.entries(categoryStats)
              .sort((a, b) => b[1].count - a[1].count)
              .map(([category, data]) => (
                <div key={category} className="chart-item">
                  <div className="chart-label">
                    <span>{category}</span>
                    <span className="chart-value">{data.count} ürün · {data.stock} stok</span>
                  </div>
                  <div className="chart-bar">
                    <div
                      className="chart-fill"
                      style={{ width: `${(data.count / products.length) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* En Çok Satan Ürünler */}
        <div className="analytics-card">
          <h3>🏆 En Çok Satan Ürünler</h3>
          <div className="top-products-list">
            {topProducts.map((product, index) => (
              <div key={product.id} className="top-product-item">
                <span className="rank">#{index + 1}</span>
                <div className="product-info">
                  <span className="product-name">{product.name}</span>
                  <span className="product-sales">{product.sales || 0} satış</span>
                </div>
                <span className="product-revenue">{((product.currentPrice || product.price) * (product.sales || 0)).toFixed(0)}₺</span>
              </div>
            ))}
          </div>
        </div>

        {/* Düşük Stok Uyarısı */}
        {lowStockProducts.length > 0 && (
          <div className="analytics-card" style={{ borderLeft: '4px solid #FF9800' }}>
            <h3>⚠️ Düşük Stok Uyarısı</h3>
            <div className="low-stock-list">
              {lowStockProducts.slice(0, 5).map(product => (
                <div key={product.id} className="low-stock-item">
                  <span className="product-name">{product.name}</span>
                  <span className="stock-badge" style={{
                    background: product.stock === 0 ? '#E5332A' : '#FF9800',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '12px'
                  }}>
                    {product.stock === 0 ? 'TÜKENDİ' : `${product.stock} kaldı`}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* En Değerli Müşteriler */}
        <div className="analytics-card">
          <h3>💎 En Değerli Müşteriler</h3>
          <div className="top-customers-list">
            {topCustomers.map((customer, index) => (
              <div key={customer.email} className="top-customer-item">
                <span className="rank">#{index + 1}</span>
                <div className="customer-info">
                  <span className="customer-name">{customer.name}</span>
                  <span className="customer-orders">{customer.orderCount} sipariş</span>
                </div>
                <span className="customer-spent">{customer.totalSpent.toFixed(0)}₺</span>
              </div>
            ))}
          </div>
        </div>

        {/* Kampanya Performansı */}
        {campaigns.length > 0 && (
          <div className="analytics-card">
            <h3>🎯 Kampanya Performansı</h3>
            <div className="campaign-performance-list">
              {campaignPerformance.map(campaign => (
                <div key={campaign.id} className="campaign-item">
                  <div className="campaign-header">
                    <span className="campaign-title">{campaign.title}</span>
                    <span className={`campaign-status ${campaign.isActive ? 'active' : 'ended'}`}>
                      {campaign.isActive ? '🟢 Aktif' : '🔴 Bitti'}
                    </span>
                  </div>
                  <div className="campaign-stats">
                    <span>{campaign.affectedProducts} ürün</span>
                    <span>·</span>
                    <span>{campaign.totalSales} satış</span>
                    <span>·</span>
                    <span>%{campaign.discount} indirim</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ==================== YENİ: CANCELLATIONS & RETURNS TAB ====================
export function ReturnsTab({
  orders = [],
  onApproveReturn,
  onRejectReturn,
  onMarkReceived,
  onCompleteReturn,
  refreshing,
  fetchAllData
}) {
  const [activeSubTab, setActiveSubTab] = useState('pending');

  const pendingReturns = orders.filter(o => o.returnStatus === 'pending');
  const approvedReturns = orders.filter(o => o.returnStatus === 'approved');
  const receivedReturns = orders.filter(o => o.returnStatus === 'received');
  const completedReturns = orders.filter(o => o.returnStatus === 'completed');
  const rejectedReturns = orders.filter(o => o.returnStatus === 'rejected');

  const getStatusColor = (status) => {
    const colors = { pending: '#FF9800', approved: '#2196F3', received: '#9C27B0', completed: '#4CAF50', rejected: '#E5332A' };
    return colors[status] || '#868e96';
  };

  const getStatusText = (status) => {
    const texts = { pending: 'Onay Bekliyor', approved: 'Onaylandı', received: 'Teslim Alındı', completed: 'Tamamlandı', rejected: 'Reddedildi' };
    return texts[status] || status;
  };

  const ReturnCard = ({ order }) => {
    const returnRequest = order.returnRequest || {};

    return (
      <div className="request-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: `${getStatusColor(order.returnStatus)}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <RotateCcw size={20} color={getStatusColor(order.returnStatus)} />
            </div>
            <div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#2B2B2B' }}>#{order.orderNumber}</div>
              <div style={{ fontSize: '13px', color: '#868e96' }}>{order.customerName}</div>
            </div>
          </div>
          <div className="request-status">{getStatusText(order.returnStatus)}</div>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
            <div className="info-box">
              <div style={{ fontSize: '12px', color: '#868e96', marginBottom: '0.25rem' }}>İade Nedeni</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>{returnRequest.reason || 'Belirtilmemiş'}</div>
            </div>
            <div className="info-box">
              <div style={{ fontSize: '12px', color: '#868e96', marginBottom: '0.25rem' }}>Sipariş Tutarı</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#E5332A' }}>{order.total?.toFixed(2)}₺</div>
            </div>
            <div className="info-box">
              <div style={{ fontSize: '12px', color: '#868e96', marginBottom: '0.25rem' }}>Talep Tarihi</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>
                {returnRequest.requestedAt ? new Date(returnRequest.requestedAt).toLocaleDateString('tr-TR') : '-'}
              </div>
            </div>
          </div>

          {returnRequest.hasDefect && (
            <div className="info-box warning">
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem', color: '#856404' }}>
                <AlertTriangle size={18} />
                <strong>Arızalı/Hasarlı Ürün</strong>
              </div>
              <div style={{ fontSize: '14px', color: '#856404' }}>{returnRequest.defectDescription || 'Açıklama yok'}</div>
            </div>
          )}

          {returnRequest.note && (
            <div className="request-note">
              <strong>Müşteri Notu:</strong>
              <div style={{ marginTop: '0.5rem' }}>{returnRequest.note}</div>
            </div>
          )}

          {returnRequest.images && returnRequest.images.length > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0.5rem', color: '#495057' }}>
                Ürün Fotoğrafları ({returnRequest.images.length})
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                {returnRequest.images.map((img, idx) => (
                  <img key={idx} src={img} alt={`İade fotoğrafı ${idx + 1}`}
                    style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #dee2e6', cursor: 'pointer' }}
                    onClick={() => window.open(img, '_blank')}
                  />
                ))}
              </div>
            </div>
          )}

          <div style={{ padding: '1rem', background: '#f8f9fa', borderRadius: '8px', marginBottom: '1rem' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0.75rem', color: '#495057' }}>Sipariş Ürünleri</div>
            {order.items?.map((item, idx) => (
              <div key={idx} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem 0',
                borderBottom: idx < order.items.length - 1 ? '1px solid #e9ecef' : 'none'
              }}>
                <div style={{ fontSize: '14px' }}>{item.name} x{item.quantity}</div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>{(item.price * item.quantity).toFixed(2)}₺</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '1rem', borderTop: '1px solid #f0f0f0' }}>
          {order.returnStatus === 'pending' && (
            <>
              <button className="btn" style={{ flex: 1, background: '#4CAF50', color: 'white', border: 'none' }}
                onClick={() => {
                  if (window.confirm('İade talebini onaylıyor musunuz?')) {
                    onApproveReturn(order.id, {
                      note: 'İade onaylandı', returnAddress: 'İade Merkezi, İstanbul',
                      instructions: 'Ürünü orijinal ambalajında kargoya veriniz.'
                    });
                  }
                }}>
                <CheckCircle size={16} /> Onayla
              </button>
              <button className="btn" style={{ flex: 1, background: '#E5332A', color: 'white', border: 'none' }}
                onClick={() => {
                  const reason = window.prompt('Red nedeni giriniz:');
                  if (reason && reason.trim()) onRejectReturn(order.id, reason);
                }}>
                <XCircle size={16} /> Reddet
              </button>
            </>
          )}

          {order.returnStatus === 'approved' && (
            <div className="info-box info" style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', color: '#0c5460' }}>
                <Truck size={18} />
                <strong>Müşteri ürünü kargoya vermeli</strong>
              </div>
            </div>
          )}

          {order.returnStatus === 'received' && (
            <button className="btn" style={{ flex: 1, background: '#9C27B0', color: 'white', border: 'none' }}
              onClick={() => {
                const condition = window.prompt('Ürün durumu:\n- good (İyi)\n- damaged (Hasarlı)\n- defective (Arızalı)', 'good');
                const note = window.prompt('İnceleme notu:');
                if (condition) onMarkReceived(order.id, { productCondition: condition, inspectionNote: note || '' });
              }}>
              <Eye size={16} /> İncelendi Olarak İşaretle
            </button>
          )}
        </div>

        {(returnRequest.approvedAt || returnRequest.receivedAt || returnRequest.completedAt) && (
          <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #f0f0f0' }}>
            <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0.75rem', color: '#495057' }}>İşlem Geçmişi</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {returnRequest.requestedAt && <div style={{ fontSize: '12px', color: '#868e96' }}>📝 Talep: {new Date(returnRequest.requestedAt).toLocaleString('tr-TR')}</div>}
              {returnRequest.approvedAt && <div style={{ fontSize: '12px', color: '#868e96' }}>✅ Onay: {new Date(returnRequest.approvedAt).toLocaleString('tr-TR')}</div>}
              {returnRequest.receivedAt && <div style={{ fontSize: '12px', color: '#868e96' }}>📦 Teslim Alındı: {new Date(returnRequest.receivedAt).toLocaleString('tr-TR')}</div>}
              {returnRequest.completedAt && <div style={{ fontSize: '12px', color: '#868e96' }}>🎉 Tamamlandı: {new Date(returnRequest.completedAt).toLocaleString('tr-TR')}</div>}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">🔄 İade Yönetimi</h2>
        <button className="btn btn-outline" onClick={fetchAllData} disabled={refreshing}>
          <RefreshCw size={18} className={refreshing ? 'spin' : ''} /> Yenile
        </button>
      </div>

      <div className="stats-grid">
        <div className="stat-card" style={{ borderColor: '#FF9800' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Onay Bekleyen</p>
              <p className="stat-value">{pendingReturns.length}</p>
              <p className="stat-subtext">İşlem gerekli</p>
            </div>
            <div className="stat-icon" style={{ background: '#FF980020' }}>
              <Clock size={26} color="#FF9800" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#2196F3' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Onaylanan</p>
              <p className="stat-value">{approvedReturns.length}</p>
              <p className="stat-subtext">Kargo bekleniyor</p>
            </div>
            <div className="stat-icon" style={{ background: '#2196F320' }}>
              <Truck size={26} color="#2196F3" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#9C27B0' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Teslim Alınan</p>
              <p className="stat-value">{receivedReturns.length}</p>
              <p className="stat-subtext">İnceleme aşamasında</p>
            </div>
            <div className="stat-icon" style={{ background: '#9C27B020' }}>
              <Eye size={26} color="#9C27B0" />
            </div>
          </div>
        </div>

        <div className="stat-card" style={{ borderColor: '#4CAF50' }}>
          <div className="stat-card-inner">
            <div>
              <p className="stat-label">Tamamlanan</p>
              <p className="stat-value">{completedReturns.length}</p>
              <p className="stat-subtext">Başarılı</p>
            </div>
            <div className="stat-icon" style={{ background: '#4CAF5020' }}>
              <CheckCircle size={26} color="#4CAF50" />
            </div>
          </div>
        </div>
      </div>

      <div className="sub-tabs">
        {[
          { id: 'pending', label: `Onay Bekleyen (${pendingReturns.length})` },
          { id: 'approved', label: `Onaylanan (${approvedReturns.length})` },
          { id: 'received', label: `Teslim Alınan (${receivedReturns.length})` },
          { id: 'completed', label: `Tamamlanan (${completedReturns.length})` },
          { id: 'rejected', label: `Reddedilen (${rejectedReturns.length})` }
        ].map(tab => (
          <button key={tab.id} className={`sub-tab ${activeSubTab === tab.id ? 'active' : ''}`} onClick={() => setActiveSubTab(tab.id)}>
            {tab.label}
          </button>
        ))}
      </div>

      <div style={{ marginTop: '1.5rem' }}>
        {activeSubTab === 'pending' && (pendingReturns.length === 0 ? (
          <div className="empty-state"><RotateCcw size={64} color="#FF9800" /><p>Bekleyen iade talebi yok</p></div>
        ) : pendingReturns.map(order => <ReturnCard key={order.id} order={order} />))}

        {activeSubTab === 'approved' && (approvedReturns.length === 0 ? (
          <div className="empty-state"><Truck size={64} color="#2196F3" /><p>Onaylanmış iade yok</p></div>
        ) : approvedReturns.map(order => <ReturnCard key={order.id} order={order} />))}

        {activeSubTab === 'received' && (receivedReturns.length === 0 ? (
          <div className="empty-state"><Eye size={64} color="#9C27B0" /><p>İnceleme bekleyen iade yok</p></div>
        ) : receivedReturns.map(order => <ReturnCard key={order.id} order={order} />))}

        {activeSubTab === 'completed' && (completedReturns.length === 0 ? (
          <div className="empty-state"><CheckCircle size={64} color="#4CAF50" /><p>Tamamlanmış iade yok</p></div>
        ) : completedReturns.map(order => <ReturnCard key={order.id} order={order} />))}

        {activeSubTab === 'rejected' && (rejectedReturns.length === 0 ? (
          <div className="empty-state"><XCircle size={64} color="#E5332A" /><p>Reddedilmiş iade yok</p></div>
        ) : rejectedReturns.map(order => <ReturnCard key={order.id} order={order} />))}
      </div>
    </div>
  );
}

// Cancellations List Component
function CancellationsList({ requests, onApprove, onReject }) {
  if (requests.length === 0) {
    return (
      <div className="empty-state">
        <XCircle size={64} color="#E5332A" />
        <p>İptal talebi bulunamadı</p>
      </div>
    );
  }

  return (
    <div className="requests-list">
      {requests.map(order => (
        <div key={order.id} className="request-card">
          <div className="request-header">
            <div className="request-info">
              <h4>#{order.orderNumber}</h4>
              <span className="request-date">
                <Clock size={14} />
                {new Date(order.cancellationRequest?.requestedAt).toLocaleString('tr-TR')}
              </span>
            </div>
            <div className={`request-status status-${order.cancelStatus}`}>
              {order.cancelStatus === 'pending' && '⏳ Beklemede'}
              {order.cancelStatus === 'approved' && '✅ Onaylandı'}
              {order.cancelStatus === 'rejected' && '❌ Reddedildi'}
            </div>
          </div>

          <div className="request-customer">
            <Users size={16} />
            <span>{order.customerName || order.customerEmail}</span>
          </div>

          <div className="request-reason">
            <AlertCircle size={16} />
            <div>
              <strong>İptal Nedeni:</strong> {order.cancellationRequest?.reason}
              {order.cancellationRequest?.reasonDetail && (
                <p className="reason-detail">{order.cancellationRequest.reasonDetail}</p>
              )}
            </div>
          </div>

          <div className="request-amount">
            <DollarSign size={16} />
            <div>
              <strong>İade Tutarı:</strong> {order.total?.toFixed(2)}₺
              <span className="refund-method">
                ({order.cancellationRequest?.refundMethod === 'card' ? 'Kart' : 'Nakit'})
              </span>
            </div>
          </div>

          {order.cancelStatus === 'pending' && (
            <div className="request-actions">
              <button
                className="btn btn-success"
                onClick={() => onApprove(order.id)}
              >
                <CheckCircle size={16} /> Onayla
              </button>
              <button
                className="btn btn-danger"
                onClick={() => onReject(order.id)}
              >
                <XCircle size={16} /> Reddet
              </button>
            </div>
          )}

          {order.cancelStatus === 'approved' && (
            <div className="request-note approved">
              ✅ İptal onaylandı - Ödeme iadesi yapıldı
            </div>
          )}

          {order.cancelStatus === 'rejected' && order.cancellationRequest?.rejectionReason && (
            <div className="request-note rejected">
              ❌ Red Nedeni: {order.cancellationRequest.rejectionReason}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// Returns List Component
function ReturnsList({ requests, onApprove, onReject, onMarkReceived, onComplete }) {
  if (requests.length === 0) {
    return (
      <div className="empty-state">
        <RotateCcw size={64} color="#E5332A" />
        <p>İade talebi bulunamadı</p>
      </div>
    );
  }

  return (
    <div className="requests-list">
      {requests.map(order => (
        <div key={order.id} className="request-card">
          <div className="request-header">
            <div className="request-info">
              <h4>#{order.orderNumber}</h4>
              <span className="request-date">
                <Clock size={14} />
                {new Date(order.returnRequest?.requestedAt).toLocaleString('tr-TR')}
              </span>
            </div>
            <div className={`request-status status-${order.returnStatus}`}>
              {order.returnStatus === 'pending' && '⏳ Beklemede'}
              {order.returnStatus === 'approved' && '✅ Onaylandı'}
              {order.returnStatus === 'received' && '📦 Teslim Alındı'}
              {order.returnStatus === 'completed' && '✅ Tamamlandı'}
              {order.returnStatus === 'rejected' && '❌ Reddedildi'}
            </div>
          </div>

          <div className="request-customer">
            <Users size={16} />
            <span>{order.customerName || order.customerEmail}</span>
          </div>

          <div className="request-reason">
            <AlertCircle size={16} />
            <div>
              <strong>İade Nedeni:</strong> {order.returnRequest?.reason}
              {order.returnRequest?.reasonDetail && (
                <p className="reason-detail">{order.returnRequest.reasonDetail}</p>
              )}
              {order.returnRequest?.hasDefect && (
                <div className="defect-info">
                  ⚠️ <strong>Kusur/Hasar:</strong> {order.returnRequest.defectDescription}
                </div>
              )}
            </div>
          </div>

          <div className="request-amount">
            <DollarSign size={16} />
            <div>
              <strong>İade Tutarı:</strong> {order.total?.toFixed(2)}₺
              <span className="refund-method">
                ({order.returnRequest?.refundMethod === 'card' ? 'Kart' : 'Nakit'})
              </span>
            </div>
          </div>

          {/* Pending - İlk Onay/Red */}
          {order.returnStatus === 'pending' && (
            <div className="request-actions">
              <button
                className="btn btn-success"
                onClick={() => onApprove(order.id)}
              >
                <CheckCircle size={16} /> Onayla
              </button>
              <button
                className="btn btn-danger"
                onClick={() => onReject(order.id)}
              >
                <XCircle size={16} /> Reddet
              </button>
            </div>
          )}

          {/* Approved - Kargo Bekleniyor */}
          {order.returnStatus === 'approved' && (
            <>
              <div className="request-note approved">
                ✅ İade onaylandı - Müşteri ürünü kargoya verecek
              </div>
              <div className="request-actions">
                <button
                  className="btn btn-primary"
                  onClick={() => onMarkReceived(order.id)}
                >
                  <Package size={16} /> Ürün Teslim Alındı
                </button>
              </div>
            </>
          )}

          {/* Received - Ürün Kontrol Ediliyor */}
          {order.returnStatus === 'received' && (
            <>
              <div className="request-note info">
                📦 Ürün teslim alındı - Kontrol ediliyor
                {order.returnRequest?.productCondition && (
                  <p>Durum: {
                    order.returnRequest.productCondition === 'good' ? '✅ İyi' :
                      order.returnRequest.productCondition === 'damaged' ? '⚠️ Hasarlı' :
                        '❌ Kusurlu'
                  }</p>
                )}
              </div>
              <div className="request-actions">
                <button
                  className="btn btn-success"
                  onClick={() => onComplete(order.id)}
                >
                  <CheckCircle size={16} /> İadeyi Tamamla ve Ödeme İade Et
                </button>
              </div>
            </>
          )}

          {/* Completed */}
          {order.returnStatus === 'completed' && (
            <div className="request-note completed">
              ✅ İade tamamlandı - Ödeme iadesi yapıldı
              {order.returnRequest?.refundTransactionId && (
                <p>İşlem No: {order.returnRequest.refundTransactionId}</p>
              )}
            </div>
          )}

          {/* Rejected */}
          {order.returnStatus === 'rejected' && order.returnRequest?.rejectionReason && (
            <div className="request-note rejected">
              ❌ Red Nedeni: {order.returnRequest.rejectionReason}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export function ReviewsTab({
  reviews = [],
  onApproveReview,
  onRejectReview,
  onDeleteReview,
  onReplyToReview,
  refreshing,
  fetchAllData
}) {
  const [activeSubTab, setActiveSubTab] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRating, setFilterRating] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [selectedReview, setSelectedReview] = useState(null);
  const [showActions, setShowActions] = useState(null);

  // İstatistikler
  const stats = {
    total: reviews.length,
    active: reviews.filter(r => r.status === 'active').length,
    pending: reviews.filter(r => r.status === 'pending').length,
    rejected: reviews.filter(r => r.status === 'rejected').length,
    verified: reviews.filter(r => r.isVerifiedPurchase).length,
    avgRating: reviews.length > 0
      ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
      : 0,
    withPhotos: reviews.filter(r => r.images && r.images.length > 0).length
  };

  // Dağılım
  const ratingDistribution = {
    5: reviews.filter(r => r.rating === 5).length,
    4: reviews.filter(r => r.rating === 4).length,
    3: reviews.filter(r => r.rating === 3).length,
    2: reviews.filter(r => r.rating === 2).length,
    1: reviews.filter(r => r.rating === 1).length
  };

  // Filtreleme
  const filteredReviews = reviews
    .filter(r => {
      if (activeSubTab === 'pending' && r.status !== 'pending') return false;
      if (activeSubTab === 'active' && r.status !== 'active') return false;
      if (activeSubTab === 'rejected' && r.status !== 'rejected') return false;
      if (activeSubTab === 'verified' && !r.isVerifiedPurchase) return false;
      if (activeSubTab === 'photos' && (!r.images || r.images.length === 0)) return false;

      const matchesSearch = !searchTerm ||
        r.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.comment?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesRating = filterRating === 'all' || r.rating === parseInt(filterRating);

      return matchesSearch && matchesRating;
    })
    .sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.createdAt) - new Date(a.createdAt);
        case 'oldest':
          return new Date(a.createdAt) - new Date(b.createdAt);
        case 'rating-high':
          return b.rating - a.rating;
        case 'rating-low':
          return a.rating - b.rating;
        case 'helpful':
          return (b.helpfulCount || 0) - (a.helpfulCount || 0);
        default:
          return 0;
      }
    });

  const renderStars = (rating) => {
    return (
      <div style={{ display: 'flex', gap: '2px' }}>
        {[1, 2, 3, 4, 5].map(star => (
          <Star
            key={star}
            size={16}
            fill={star <= rating ? '#FFB800' : 'none'}
            color={star <= rating ? '#FFB800' : '#dee2e6'}
          />
        ))}
      </div>
    );
  };

  const ReviewCard = ({ review }) => {
    const getStatusStyle = () => {
      const styles = {
        active: { bg: '#d4edda', color: '#155724', border: '#c3e6cb' },
        pending: { bg: '#fff3cd', color: '#856404', border: '#ffeaa7' },
        rejected: { bg: '#f8d7da', color: '#721c24', border: '#f5c6cb' }
      };
      return styles[review.status] || styles.pending;
    };

    const statusStyle = getStatusStyle();

    return (
      <div style={{
        background: 'white',
        border: '1px solid #e9ecef',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '1rem'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '18px',
              fontWeight: '600',
              flexShrink: 0
            }}>
              {review.userName?.[0]?.toUpperCase() || 'A'}
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
                <span style={{ fontSize: '15px', fontWeight: '600', color: '#2B2B2B' }}>
                  {review.userName || 'Anonim'}
                </span>
                {review.isVerifiedPurchase && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem',
                    padding: '2px 8px',
                    background: '#d4edda',
                    borderRadius: '12px',
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#155724'
                  }}>
                    <ShieldCheck size={12} />
                    Doğrulanmış
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                {renderStars(review.rating)}
                <span style={{ fontSize: '13px', color: '#868e96' }}>
                  {review.createdAt ? new Date(review.createdAt).toLocaleDateString('tr-TR') : 'Tarih yok'}
                </span>
              </div>

              <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '0.5rem' }}>
                Ürün: <strong>{review.productName}</strong>
              </div>

              {review.title && (
                <div style={{ fontSize: '15px', fontWeight: '600', color: '#2B2B2B', marginBottom: '0.5rem' }}>
                  {review.title}
                </div>
              )}

              <div style={{ fontSize: '14px', color: '#495057', lineHeight: '1.6' }}>
                {review.comment}
              </div>

              {review.images && review.images.length > 0 && (
                <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.75rem', flexWrap: 'wrap' }}>
                  {review.images.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt={`Değerlendirme ${idx + 1}`}
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                        border: '2px solid #e9ecef',
                        cursor: 'pointer'
                      }}
                      onClick={() => window.open(img, '_blank')}
                    />
                  ))}
                </div>
              )}

              {review.helpfulCount > 0 && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  marginTop: '0.75rem',
                  fontSize: '13px',
                  color: '#6c757d'
                }}>
                  <ThumbsUp size={14} />
                  <span>{review.helpfulCount} kişi faydalı buldu</span>
                </div>
              )}

              {review.adminReply && (
                <div style={{
                  marginTop: '1rem',
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  borderLeft: '3px solid #667eea'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <Award size={16} color="#667eea" />
                    <strong style={{ fontSize: '13px', color: '#667eea' }}>Satıcı Yanıtı</strong>
                  </div>
                  <div style={{ fontSize: '14px', color: '#495057' }}>
                    {review.adminReply.message}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem' }}>
            <div style={{
              padding: '6px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: '600',
              background: statusStyle.bg,
              color: statusStyle.color,
              border: `1px solid ${statusStyle.border}`
            }}>
              {review.status === 'active' ? 'Yayında' : review.status === 'pending' ? 'Beklemede' : 'Reddedildi'}
            </div>

            <div style={{ position: 'relative' }}>
              <button
                onClick={() => setShowActions(showActions === review.id ? null : review.id)}
                style={{
                  width: '32px',
                  height: '32px',
                  border: '1px solid #e9ecef',
                  background: 'white',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                <MoreVertical size={18} />
              </button>

              {showActions === review.id && (
                <div style={{
                  position: 'absolute',
                  right: 0,
                  top: '100%',
                  marginTop: '0.5rem',
                  background: 'white',
                  border: '1px solid #e9ecef',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  minWidth: '180px',
                  zIndex: 1000,
                  overflow: 'hidden'
                }}>
                  {review.status === 'pending' && (
                    <>
                      <button
                        onClick={() => {
                          onApproveReview(review.id);
                          setShowActions(null);
                        }}
                        style={{
                          width: '100%',
                          padding: '0.75rem 1rem',
                          border: 'none',
                          background: 'none',
                          textAlign: 'left',
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}
                      >
                        <CheckCircle size={16} color="#4CAF50" />
                        Onayla
                      </button>
                      <button
                        onClick={() => {
                          const reason = prompt('Red nedeni:');
                          if (reason) {
                            onRejectReview(review.id, reason);
                            setShowActions(null);
                          }
                        }}
                        style={{
                          width: '100%',
                          padding: '0.75rem 1rem',
                          border: 'none',
                          background: 'none',
                          textAlign: 'left',
                          fontSize: '14px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}
                      >
                        <XCircle size={16} color="#E5332A" />
                        Reddet
                      </button>
                    </>
                  )}

                  <button
                    onClick={() => {
                      setSelectedReview(review);
                      setShowActions(null);
                    }}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: 'none',
                      background: 'none',
                      textAlign: 'left',
                      fontSize: '14px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    <MessageSquare size={16} />
                    Yanıtla
                  </button>

                  <button
                    onClick={() => {
                      if (window.confirm('Bu değerlendirmeyi silmek istediğinizden emin misiniz?')) {
                        onDeleteReview(review.id);
                        setShowActions(null);
                      }
                    }}
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: 'none',
                      background: 'none',
                      textAlign: 'left',
                      fontSize: '14px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: '#E5332A'
                    }}
                  >
                    <Trash2 size={16} />
                    Sil
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#2B2B2B', margin: 0 }}>
          ⭐ Değerlendirme Yönetimi
        </h2>
        <button
          onClick={fetchAllData}
          disabled={refreshing}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            border: '1px solid #e9ecef',
            background: 'white',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '600'
          }}
        >
          <RefreshCw size={18} style={{ animation: refreshing ? 'spin 1s linear infinite' : 'none' }} />
          Yenile
        </button>
      </div>

      {/* İstatistikler */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1rem',
        marginBottom: '2rem'
      }}>
        <div style={{
          background: 'white',
          border: '2px solid #667eea',
          borderRadius: '12px',
          padding: '1.5rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <p style={{ fontSize: '13px', color: '#868e96', margin: '0 0 0.5rem 0' }}>Toplam</p>
              <p style={{ fontSize: '32px', fontWeight: '700', color: '#2B2B2B', margin: '0 0 0.5rem 0' }}>
                {stats.total}
              </p>
              <p style={{ fontSize: '12px', color: '#868e96', margin: 0 }}>Ort: {stats.avgRating} ⭐</p>
            </div>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'rgba(102, 126, 234, 0.1)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Star size={26} color="#667eea" />
            </div>
          </div>
        </div>

        <div style={{
          background: 'white',
          border: '2px solid #FF9800',
          borderRadius: '12px',
          padding: '1.5rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <p style={{ fontSize: '13px', color: '#868e96', margin: '0 0 0.5rem 0' }}>Bekleyen</p>
              <p style={{ fontSize: '32px', fontWeight: '700', color: '#2B2B2B', margin: '0 0 0.5rem 0' }}>
                {stats.pending}
              </p>
              <p style={{ fontSize: '12px', color: '#868e96', margin: 0 }}>İşlem gerekli</p>
            </div>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'rgba(255, 152, 0, 0.1)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <AlertCircle size={26} color="#FF9800" />
            </div>
          </div>
        </div>

        <div style={{
          background: 'white',
          border: '2px solid #4CAF50',
          borderRadius: '12px',
          padding: '1.5rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <p style={{ fontSize: '13px', color: '#868e96', margin: '0 0 0.5rem 0' }}>Yayında</p>
              <p style={{ fontSize: '32px', fontWeight: '700', color: '#2B2B2B', margin: '0 0 0.5rem 0' }}>
                {stats.active}
              </p>
              <p style={{ fontSize: '12px', color: '#868e96', margin: 0 }}>
                {stats.total > 0 ? Math.round((stats.active / stats.total) * 100) : 0}% onay
              </p>
            </div>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'rgba(76, 175, 80, 0.1)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <CheckCircle size={26} color="#4CAF50" />
            </div>
          </div>
        </div>

        <div style={{
          background: 'white',
          border: '2px solid #2196F3',
          borderRadius: '12px',
          padding: '1.5rem'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <p style={{ fontSize: '13px', color: '#868e96', margin: '0 0 0.5rem 0' }}>Doğrulanmış</p>
              <p style={{ fontSize: '32px', fontWeight: '700', color: '#2B2B2B', margin: '0 0 0.5rem 0' }}>
                {stats.verified}
              </p>
              <p style={{ fontSize: '12px', color: '#868e96', margin: 0 }}>{stats.withPhotos} fotoğraf</p>
            </div>
            <div style={{
              width: '48px',
              height: '48px',
              background: 'rgba(33, 150, 243, 0.1)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <ShieldCheck size={26} color="#2196F3" />
            </div>
          </div>
        </div>
      </div>

      {/* Dağılım */}
      <div style={{
        background: 'white',
        border: '1px solid #e9ecef',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '1.5rem'
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '1rem', color: '#2B2B2B' }}>
          📊 Derecelendirme Dağılımı
        </h3>
        {[5, 4, 3, 2, 1].map(rating => {
          const count = ratingDistribution[rating];
          const percentage = stats.total > 0 ? (count / stats.total) * 100 : 0;

          return (
            <div key={rating} style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', minWidth: '80px' }}>
                <span style={{ fontSize: '14px', fontWeight: '600' }}>{rating}</span>
                <Star size={14} fill="#FFB800" color="#FFB800" />
              </div>
              <div style={{
                flex: 1,
                height: '8px',
                background: '#f0f0f0',
                borderRadius: '4px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${percentage}%`,
                  height: '100%',
                  background: rating >= 4 ? '#4CAF50' : rating === 3 ? '#FF9800' : '#E5332A',
                  transition: 'width 0.3s ease'
                }} />
              </div>
              <span style={{ fontSize: '14px', color: '#868e96', minWidth: '80px', textAlign: 'right' }}>
                {count} ({percentage.toFixed(0)}%)
              </span>
            </div>
          );
        })}
      </div>

      {/* Filtreler */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div style={{
          flex: 1,
          minWidth: '250px',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          background: 'white',
          border: '1px solid #e9ecef',
          borderRadius: '8px'
        }}>
          <Search size={18} color="#adb5bd" />
          <input
            type="text"
            placeholder="Ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              border: 'none',
              outline: 'none',
              fontSize: '14px',
              background: 'transparent'
            }}
          />
        </div>

        <select
          value={filterRating}
          onChange={(e) => setFilterRating(e.target.value)}
          style={{
            padding: '0.75rem 1rem',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            fontSize: '14px',
            background: 'white',
            cursor: 'pointer'
          }}
        >
          <option value="all">Tüm Puanlar</option>
          <option value="5">⭐⭐⭐⭐⭐ (5)</option>
          <option value="4">⭐⭐⭐⭐ (4)</option>
          <option value="3">⭐⭐⭐ (3)</option>
          <option value="2">⭐⭐ (2)</option>
          <option value="1">⭐ (1)</option>
        </select>

        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          style={{
            padding: '0.75rem 1rem',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            fontSize: '14px',
            background: 'white',
            cursor: 'pointer'
          }}
        >
          <option value="newest">En Yeni</option>
          <option value="oldest">En Eski</option>
          <option value="rating-high">En Yüksek Puan</option>
          <option value="rating-low">En Düşük Puan</option>
          <option value="helpful">En Faydalı</option>
        </select>
      </div>

      {/* Alt Sekmeler - GÜNCEL (KIRMIZI) */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', overflowX: 'auto' }}>
        {[
          { id: 'all', label: `Tümü (${stats.total})` },
          { id: 'pending', label: `Bekleyen (${stats.pending})` },
          { id: 'active', label: `Yayında (${stats.active})` },
          { id: 'rejected', label: `Reddedilen (${stats.rejected})` },
          { id: 'verified', label: `Doğrulanmış (${stats.verified})` },
          { id: 'photos', label: `Fotoğraflı (${stats.withPhotos})` }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            style={{
              padding: '0.75rem 1.25rem',
              border: '1px solid #e9ecef',
              background: activeSubTab === tab.id ? '#E5332A' : 'white',  // ← KIRMIZI
              color: activeSubTab === tab.id ? 'white' : '#495057',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',  // ← BOLD
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (activeSubTab !== tab.id) {
                e.currentTarget.style.background = 'rgba(229, 51, 42, 0.05)';
                e.currentTarget.style.color = '#E5332A';
                e.currentTarget.style.borderColor = '#E5332A';
              }
            }}
            onMouseLeave={(e) => {
              if (activeSubTab !== tab.id) {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#495057';
                e.currentTarget.style.borderColor = '#e9ecef';
              }
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Liste */}
      <div>
        {filteredReviews.length === 0 ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '4rem 2rem',
            textAlign: 'center',
            background: 'white',
            border: '2px dashed #e9ecef',
            borderRadius: '12px'
          }}>
            <Star size={64} color="#dee2e6" style={{ marginBottom: '1rem' }} />
            <p style={{ fontSize: '16px', color: '#868e96' }}>Değerlendirme bulunamadı</p>
          </div>
        ) : (
          filteredReviews.map(review => <ReviewCard key={review.id} review={review} />)
        )}
      </div>

      {/* Yanıt Modal */}
      {selectedReview && (
        <div
          onClick={() => setSelectedReview(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '1rem'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white',
              borderRadius: '16px',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '1.5rem',
              borderBottom: '1px solid #e9ecef'
            }}>
              <h3 style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>💬 Değerlendirmeye Yanıt Ver</h3>
              <button
                onClick={() => setSelectedReview(null)}
                style={{
                  width: '32px',
                  height: '32px',
                  border: 'none',
                  background: '#f8f9fa',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
              >
                <X size={20} />
              </button>
            </div>

            <div style={{ padding: '1.5rem', overflowY: 'auto', flex: 1 }}>
              <div style={{
                padding: '1rem',
                background: '#f8f9fa',
                borderRadius: '8px',
                marginBottom: '1.5rem'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                  <strong>{selectedReview.userName}</strong>
                  {renderStars(selectedReview.rating)}
                </div>
                <p style={{ fontSize: '14px', color: '#495057', margin: 0 }}>
                  {selectedReview.comment}
                </p>
              </div>

              <form onSubmit={(e) => {
                e.preventDefault();
                const message = e.target.message.value;
                if (message.trim()) {
                  onReplyToReview(selectedReview.id, message);
                  setSelectedReview(null);
                }
              }}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057',
                    marginBottom: '0.5rem'
                  }}>
                    Yanıtınız
                  </label>
                  <textarea
                    name="message"
                    rows="4"
                    required
                    placeholder="Müşteriye yanıtınızı yazın..."
                    style={{
                      width: '100%',
                      padding: '0.75rem 1rem',
                      border: '1px solid #e9ecef',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                      resize: 'vertical'
                    }}
                  />
                </div>

                <div style={{ display: 'flex', gap: '1rem' }}>
                  <button
                    type="button"
                    onClick={() => setSelectedReview(null)}
                    style={{
                      padding: '0.75rem 1.5rem',
                      border: '1px solid #e9ecef',
                      background: 'white',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    İptal
                  </button>
                  <button
                    type="submit"
                    style={{
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      padding: '0.75rem 1.5rem',
                      border: 'none',
                      background: '#E5332A',  // ← KIRMIZI (667eea → E5332A)
                      color: 'white',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    <Send size={18} />
                    Yanıtı Gönder
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default {
  DashboardTab,
  ProductsTab,
  DiscountsTab,
  CampaignsTab,
  ReportsTab,
  OrdersTab,
  CustomersTab,
  ReturnsTab,
  ReviewsTab,
  VisitorsTab
};